import generated from "./generated.json";

export const translations = {
  en: {
    seo: {
      breadcrumbHome: "Home",
      keywords: "MargTor, electric mobility Africa, EV engineering Kenya, electric boda boda, electric three-wheeler, EZEEGO, KRAZEE, battery swap station, solar charging infrastructure, ESS energy storage, white label EV manufacturing, electric boat motors, fleet telematics, TCO electric motorcycle, BGK, KUKE, Team Poland, EV technical partner, Nairobi, Kinshasa, Dar es Salaam",
      home: {
        title: "Electric Mobility Engineering for Africa — EV Fleets, Battery Swap & Solar Charging",
        description: "MargTor Ltd. is the B2B technical partner for electric mobility in Kenya, DRC and Tanzania: EV 2W/3W fleet engineering, electric boats, battery swap & solar charging, ESS and white-label manufacturing. Kenyan, Indian and Polish engineering heritage.",
        ogAlt: "MargTor — Precision Electric Mobility, Engineered for Africa. Boda-boda rider in Kenya.",
      },
      partners: {
        title: "Partner Program — How Companies Engage MargTor",
        description: "A 6-step engagement path from discovery call to operated fleet: technical audit, engineered proposal, pilot deployment, scale-up and long-term support. For fleet operators, cooperatives, energy developers, governments and investors.",
        ogAlt: "MargTor Partner Program — the engagement path from discovery call to operated EV fleet.",
        breadcrumb: "Partner Program",
      },
      press: {
        title: "Press Kit — Boilerplate, Founder Bios, Portraits & Logos",
        description: "Media information about MargTor Ltd.: company boilerplate (EN/PL), fact sheet, bios and studio portraits of founders Gurinder Oberoi Singh and Gregory Radek, logos and partnership briefs. Texts CC BY 4.0; images for editorial use.",
        ogAlt: "MargTor Ltd. press kit — boilerplate, founder portraits and logos.",
        breadcrumb: "Press Kit",
      },
      knowledge: {
        title: "Knowledge Hub — Electric Mobility in East Africa",
        description: "Articles and glossary on boda-boda economics, battery swapping, Battery-as-a-Service, TCO, solar swap hubs, energy storage, telematics-secured credit, cooperatives, BGK/KUKE export financing and electric boats. CC BY 4.0.",
        ogAlt: "MargTor Knowledge Hub — electric mobility in East Africa.",
        breadcrumb: "Knowledge Hub",
      },
    },
    chat: {
      launcher: "Ask MargTor",
      close: "Close",
      eyebrow: "Knowledge Hub assistant",
      title: "Ask MargTor",
      welcome: "Ask anything about electric fleets, battery swapping, TCO, financing or MargTor's partner model. Answers come from our Knowledge Hub.",
      suggestions: ["How does battery swapping work for boda-bodas?", "What does an electric boda save per day vs petrol?", "How can BGK/KUKE finance a swap network?"],
      placeholder: "Type your question…",
      send: "Send",
      typing: "Thinking…",
      contactCta: "Talk to the team",
      error: "The assistant is unavailable right now — our team will gladly answer directly.",
      disclaimer: "AI answers from margtor.africa content · no prices · may be imperfect",
    },
    booking: {
      eyebrow: "Discovery call",
      title: "Book a 45-minute discovery call.",
      desc: "Pick a slot, tell us about your fleet, lake or site, and we will confirm by email with a calendar invite. Feasibility read within 48 hours after the call.",
      tz: "Nairobi time (EAT, UTC+3) · Mon–Fri 10:00–16:00",
      step1: "1 · Choose a day",
      step2: "2 · Choose a time",
      step3: "3 · Your details",
      name: "Full name", email: "Work email", company: "Company / cooperative", phone: "Phone (optional)", topic: "What would you like to discuss?",
      selected: "Selected", pickSlot: "Pick a day and time first", submit: "Confirm booking", sending: "Booking…",
      taken: "That slot was just taken — please pick another.", error: "Could not complete the booking. Please try again or use the contact form.",
      successToast: "Discovery call booked", confirmed: "Booked", emailSent: "A confirmation with calendar invite was sent to your email.",
      emailPending: "Your booking is saved; add it to your calendar below.", ics: "Download .ics", gcal: "Add to Google Calendar",
      meet: "Join via Google Meet", meetReady: "The Google Meet link is in your invite.", syncedBadge: "Automatic Google Meet invite",
    },
    knowledge: {
      loadError: "Could not load the Knowledge Hub right now.",
      retry: "Try again",
      eyebrow: "Knowledge Hub",
      title: "Electric mobility in East Africa — explained from the field.",
      desc: "Eleven engineering-grade articles and a glossary on boda-boda economics, battery swapping, Battery-as-a-Service, TCO, solar hubs, storage, telematics-secured credit, cooperatives, export financing and electric boats. Open to people and AI agents under CC BY 4.0.",
      articlesEyebrow: "Articles",
      articlesTitle: "What a fleet operator, lender or policymaker needs to know.",
      glossaryEyebrow: "Glossary",
      glossaryTitle: "Twenty terms that keep coming up.",
      minRead: "min read",
      updated: "Updated",
      toolsEyebrow: "Use this article",
      cite: "Copy citation",
      citeCopied: "Citation copied",
      citeFailed: "Could not copy the citation.",
      openMarkdown: "Markdown version",
      openJson: "JSON version",
      related: "Related reading",
      backToHub: "Knowledge Hub",
      notFound: "Article not found.",
      ctaTitle: "Planning a deployment?",
      ctaDesc: "MargTor engineers the vehicles, the swap network and the financing pack as one system.",
      license: { label: "License", attribution: "attribute to MargTor Ltd., margtor.africa" },
      notes: {
        eyebrow: "Field Notes",
        title: "Gregory Radek's column — what you see from Nairobi, not from a conference room.",
        desc: "Short posts by East Africa's leading expert on electric two- and three-wheelers. Personal, numerical, quotable.",
        byline: "Gregory Radek · Co-Founder & CTO · EV 2W/3W expert, East Africa",
        read: "Read the note", back: "Field Notes", kind: "Field note", linkedin: "Follow on LinkedIn",
      },
      press: { eyebrow: "In the press", title: "What the press writes about us.", read: "Read the source", ours: "Our analysis" },
      agents: {
        eyebrow: "For AI agents & crawlers",
        title: "Machine-readable, by design.",
        desc: "Every page and article is available as Markdown and JSON, with schema.org data, Atom/JSON feeds, open datasets and an MCP server exposing a TCO calculator and knowledge search. Indexing, summarising and training are allowed with attribution.",
        links: { llms: "llms.txt", llmsFull: "llms-full.txt (full context)", markdown: "Knowledge index (Markdown)", mcp: "MCP server (streamable HTTP)", datasets: "Open datasets (JSON / CSV)", feed: "Atom feed", agentCard: "A2A agent card", openapi: "OpenAPI spec" },
      },
    },
    nav: {
      knowledge: "Knowledge",
      solutions: "Solutions",
      manifesto: "Engineering",
      markets: "Markets",
      ecosystem: "Ecosystem",
      founders: "Founders",
      financing: "Financing",
      economics: "Economics",
      micro: "Off-Grid",
      contact: "Contact",
      cta: "Partner With Us",
      ops: "Nairobi • Kinshasa • Dar es Salaam",
    },
    hero: {
      eyebrow: "MargTor Ltd. — Est. 2024 / Nairobi HQ",
      l1: "Precision Electric",
      l2: "Mobility, Engineered",
      l3: "for Africa.",
      sub: "Kenyan ingenuity fused with Indian and Polish industrial heritage. Companies hire MargTor as their technical partner for EV — we engineer, deploy and support 2W & 3W fleets, electric fishing and tourist boats, and solar-ready charging infrastructure. Trading petrol and diesel for the sunshine Africa is blessed with.",
      cta1: "Explore Solutions",
      cta2: "Become a Partner",
      coords: "01°17′S 36°49′E — NAIROBI",
      telemetry: "LIVE FLEET TELEMETRY",
      imgAlt: "Boda boda riders on a dusty Kenyan street — the world MargTor engineers for",
      stats: [
        { val: "500+", label: "KG Payload Class" },
        { val: "<45s", label: "Battery Swap Time" },
        { val: "03", label: "Active Markets" },
        { val: "50+", label: "Yrs Combined Heritage" },
      ],
    },
    marquee: [
      "EV 2W & 3W COMMERCIAL PLATFORMS",
      "MARINE INBOARD & OUTBOARD MOTORS",
      "AC / DC FAST CHARGING",
      "AUTOMATED BATTERY SWAP HUBS",
      "INDUSTRIAL ESS STORAGE",
      "BATTERY & ESS PARTNER NETWORK",
      "WHITE LABEL OEM SOLUTIONS",
      "KENYA • DRC • TANZANIA",
    ],
    manifesto: {
      eyebrow: "The MargTor Doctrine",
      title: "We don't import vehicles. We engineer them for where they will actually work.",
      chapters: [
        {
          num: "01",
          title: "Purpose-Built for Local Terrain",
          desc: "Off-the-shelf imports fail on corrugated roads, steep gradients and high humidity. We engineer chassis, thermal systems and suspension explicitly for East & Central African duty cycles.",
        },
        {
          num: "02",
          title: "Tri-Continental Engineering DNA",
          desc: "Founded in 2024 with deep roots in Indian automotive mass-manufacturing and Polish high-precision EV power electronics — through the Amperi, electro.technology and Hadron Energy ecosystem.",
        },
        {
          num: "03",
          title: "Decentralized Swappable Power",
          desc: "We eliminate charging downtime for boda operators and fishing fleets with standardized modular packs and intelligent swap lockers — energy that moves at the speed of work.",
        },
        {
          num: "04",
          title: "White Label for Local Partners",
          desc: "Proven EV platforms manufactured under your brand — so local companies, cooperatives and public initiatives can electrify their fleets fast, backed by our engineering, telematics and battery group.",
        },
      ],
    },
    products: {
      eyebrow: "Capabilities Matrix",
      title: "One technical partner for the entire EV stack.",
      desc: "Select a capability to review what we engineer, integrate and deploy.",
      specLabel: "Deployment Spec",
      items: [
        {
          key: "ev",
          code: "MGT-EV",
          name: "EV 2W & 3W Fleet Engineering",
          desc: "We engineer heavy-duty electric motorcycle and 3-wheel cargo & passenger platforms: reinforced chassis, powertrain integration, homologation and fleet telemetry — industrialized with our manufacturing partners.",
          specs: ["Up to 140 km range", "300–650 kg payload", "IP67 sealed battery", "Regenerative braking"],
          img: "/assets/img/boda-karen.jpg",
        },
        {
          key: "marine",
          code: "MGT-MR",
          name: "Electric Boat Motors — Inboard & Outboard",
          desc: "Zero-emission propulsion for fishing and tourist boats on Lake Victoria, Lake Tanganyika and coastal routes. Direct-drive torque in corrosion-resistant alloy housings.",
          specs: ["5–80 kW continuous output", "Closed-loop liquid cooling", "Silent eco / patrol mode", "Salt & freshwater certified"],
          img: "/assets/img/marine.jpg",
        },
        {
          key: "charging",
          code: "MGT-CH",
          name: "AC / DC Charging & Swap Stations",
          desc: "Grid-resilient DC fast-charging hubs and automated battery-swap kiosks with cloud billing, thermal monitoring and anti-theft telemetry.",
          specs: ["<45 s swap cycle", "Solar micro-grid ready", "12 slots · 16 kW per cabinet", "Dual AC/DC output"],
          img: "/assets/img/swap-cabinet.jpg",
        },
        {
          key: "ess",
          code: "MGT-ES",
          name: "Industrial ESS — Energy Storage",
          desc: "Containerized and rack-mount storage for commercial facilities, microgrids and off-grid charging depots.",
          specs: ["50 kWh – 2 MWh scalable", "LFP chemistry, 4000+ cycles", "Smart BMS + fire suppression", "Peak shaving & backup"],
          img: "/assets/img/ess.jpg",
        },
        {
          key: "iot",
          code: "MGT-IOT",
          name: "Fleet Telematics & IoT Control",
          desc: "Every platform ships with an IoT device embedded inside the motor controller — tampering immobilizes the vehicle. Live CAN-bus diagnostics, remote disable, reverse-only anti-theft lock, geo-fencing and localized speed limiting.",
          specs: ["IoT embedded in FarDriver controller", "Live CAN diagnostics", "Remote disable & geo-fencing", "4G → 2G → SMS → LoRa fallback", "Fintech APIs — KCB, Equity"],
          img: "/assets/img/engineering.jpg",
        },
        {
          key: "white",
          code: "MGT-WL",
          name: "White Label Manufacturing",
          desc: "Proven 2W/3W platforms, boat powertrains and swap infrastructure manufactured under your brand — CKD/SKD assembly kits, fleet telematics and localization training for deployment partners.",
          specs: ["Proven platform blueprints", "Your brand, our engineering", "Dedicated telematics API", "Assembly & localization training"],
          img: "/assets/img/assembly-line.png",
        },
      ],
    },
    field: {
      eyebrow: "Field Reality",
      title: "This is the world our engineering answers to.",
      desc: "Real streets, real duty cycles. Dust, load, distance — photographed where our platforms will actually work.",
      items: [
        { img: "/assets/img/field-1.jpg", cap: "Cargo boda — Nairobi highway" },
        { img: "/assets/img/field-2.jpg", cap: "Boda stage — Bagamoyo, Tanzania" },
        { img: "/assets/img/field-3.jpg", cap: "Livestock run — rural Tanzania" },
        { img: "/assets/img/field-4.jpg", cap: "Rush-hour stage — Nairobi" },
        { img: "/assets/img/field-5.jpg", cap: "Urban commute — Nairobi" },
      ],
    },
    models: {
      eyebrow: "Engineering, Proven in Hardware",
      title: "Reference platforms our team works on — and what MargTor adds to each.",
      desc: "Two families of proven hardware. TANK, SUPER TANK and TIGER are Amperi platforms (amperi.eu, designed with electro.technology); MargTor's scope on them is tropical adaptation, Kenyan homologation, telematics integration and local assembly. KRAZEE and EZEEGO were engineered and ARAI-homologated in India by the team of our co-founder Gurinder Oberoi Singh.",
      note: "MargTor is an engineering partner, not a vehicle shop — B2B and B2C sales run through a separate distribution entity. Specifications are the manufacturers' published figures.",
      platformLabel: "Platform",
      scopeLabel: "MargTor scope",
      items: [
        { code: "TANK", cat: "2W Commuter", img: "/assets/img/models/cut/tank.png", specs: ["55 km/h", "2.0 kW hub · 3.5 kW peak", "72 V · 80 kg"], platform: "Amperi · amperi.eu", scope: "Tropical adaptation, homologation, telematics, assembly" },
        { code: "SUPER TANK", cat: "2W Commuter+", img: "/assets/img/models/cut/super-tank.png", specs: ["70 km/h", "3.0 kW hub · 5.5 kW peak", "72 V · 88 kg"], platform: "Amperi · amperi.eu", scope: "Tropical adaptation, homologation, telematics, assembly" },
        { code: "TIGER", cat: "2W Performance", img: "/assets/img/models/cut/tiger.png", specs: ["120 km/h", "7.0 kW hub · 12 kW peak", "72 V · 97 kg"], platform: "Amperi · amperi.eu", scope: "Tropical adaptation, homologation, telematics, assembly" },
        { code: "KRAZEE LITE", cat: "2W Boda", img: "/assets/img/models/krazee-lite.png", specs: ["75 km/h", "3.0 kW mid · 5 kW peak", "72 V · 115 kg"], platform: "VGK Electric (India) · G. O. Singh", scope: "Engineered & ARAI-homologated by the co-founder's team" },
        { code: "KRAZEE EV50", cat: "2W Boda+", img: "/assets/img/models/cut/krazee-ev50.png", specs: ["85 km/h", "3.5 kW mid · 6 kW peak", "72 V · 125 kg"], platform: "VGK Electric (India) · G. O. Singh", scope: "Engineered & ARAI-homologated by the co-founder's team" },
        { code: "KRAZEE EX5", cat: "2W Street", img: "/assets/img/models/cut/krazee-ex5.png", specs: ["95 km/h", "4.0 kW mid · 7 kW peak", "72 V · 125 kg"], platform: "VGK Electric (India) · G. O. Singh", scope: "Engineered & ARAI-homologated by the co-founder's team" },
        { code: "THREE-SEATER", cat: "EZEEGO · 3W Passenger", img: "/assets/img/models/cut/three-seater.png", specs: ["60 km/h", "3 kW PMSM · 9.2 kWh", "130–150 km · GVW 750 kg"], platform: "EZEEGO · VGK Electric (India)", scope: "Engineered & ARAI-homologated by the co-founder's team" },
        { code: "SIX-SEATER", cat: "EZEEGO · 3W Passenger XL", img: "/assets/img/models/cut/six-seater.png", specs: ["60 km/h", "5 kW PMSM · 11.5 kWh", "5-yr / 100k km warranty"], platform: "EZEEGO · VGK Electric (India)", scope: "Engineered & ARAI-homologated by the co-founder's team" },
        { code: "CARGO", cat: "EZEEGO · 3W Heavy Cargo", img: "/assets/img/models/cut/cargo.png", specs: ["50 km/h", "5 kW PMSM", "130 km · GVW 1000 kg"], platform: "EZEEGO · VGK Electric (India)", scope: "Engineered & ARAI-homologated by the co-founder's team" },
      ],
    },
    markets: {
      eyebrow: "Operational Footprint",
      title: "Deployed where reliability is non-negotiable.",
      desc: "Active service operations across East and Central Africa — with local assembly, parts and field engineering support.",
      items: [
        {
          country: "Kenya",
          tag: "HQ & Assembly",
          cities: "Nairobi • Mombasa • Kisumu",
          focus: "2W/3W fleet deployment, marine testing on Lake Victoria, high-density solar swap networks.",
          coords: "01°17′S 36°49′E",
        },
        {
          country: "DR Congo",
          tag: "Cargo Corridors",
          cities: "Kinshasa • Lubumbashi • Goma",
          focus: "Heavy 3W logistics, mining transit support, off-grid ESS and microgrid charging.",
          coords: "04°19′S 15°18′E",
        },
        {
          country: "Tanzania",
          tag: "Maritime & Fleets",
          cities: "Dar es Salaam • Arusha",
          focus: "Electric watercraft conversion for fishing and lake transport, peri-urban passenger fleets.",
          coords: "06°47′S 39°12′E",
        },
      ],
    },
    micro: {
      deck: { eyebrow: "Case presentation", title: "Powering African Micro-Economies (PDF, 15 slides)", desc: "How a solar swap hub becomes a village micro-utility: ~20 local jobs per hub, cold-chain and farm transport that cuts crop spoilage, women's cooperatives as owners, mobile-money micro-payments. A field-proven example of MargTor technology changing lives in rural areas and small towns.", cta: "Open the presentation" },
      eyebrow: "Off-Grid Micro-Utilities",
      title: "One hub can electrify a village — and it earns on every charge.",
      desc: "The MargTor swap hub is a decentralized micro-utility: solar canopy, storage and smart lockers in one footprint. The operating model follows an external reference: a Kenyan swap network run by a third-party operator with about 2,000 e-motos and 70 stations serving Saccos and women's cooperatives (operator-reported figures, not a MargTor deployment).",
      proof: ["Reference: ~2,000 e-motos", "~70 swap stations (third-party operator, Kenya)", "Saccos & women's cooperatives"],
      stats: [
        { val: "30 km", label: "Radius per Hub" },
        { val: "~20", label: "Local Jobs per Hub" },
        { val: "2 wks", label: "Home Lighting per Battery" },
        { val: "230 V", label: "Standard Home Socket" },
        { val: "24", label: "Packs Cycled / Day" },
        { val: "24/7", label: "Design Target · Generator Failsafe" },
      ],
      cards: [
        { title: "Homes", desc: "The same battery that powers a boda powers a household: up to two weeks of basic lighting, fans, small fridges and essential electronics through a standard 230 V socket." },
        { title: "Fishing Boats", desc: "A universal pack for lakes where petrol engines are restricted — clean propulsion for fishing and lake transport without a fuel dock in sight." },
        { title: "The Hub Earns on Charging", desc: "Solar-first power is the cheapest input; even off-grid pricing stays far below petrol equivalents. Frictionless daily micro-payments via mobile money turn every swap into margin — and the operator into the local energy network." },
        { title: "Independent When It Matters", desc: "Solar primary, grid optional, automated generator failsafe — designed to keep swapping through extreme weather or a total grid outage. When fuel imports stall in an energy crisis, these villages keep moving." },
      ],
      note: "No national grid investment required. A hub bypasses the slow grid entirely — instant rural electrification with local jobs attached.",
    },
    financing: {
      eyebrow: "Bankable by Design",
      title: "Every program ships with financing-ready documentation.",
      desc: "MargTor programs come with ready, bankable project plans and documentation built for financing applications — so capital is a step in the plan, not a bottleneck.",
      cards: [
        { title: "Bankable Project Plans", desc: "Feasibility studies, TCO-versus-petrol models, cash-flow forecasts and risk registers — prepared to credit-committee standard for every deployment." },
        { title: "Team Poland Framework", desc: "We work within Team Poland — the joint brand of six Polish development institutions (PFR, BGK, PAIH, KUKE, PARP, ARP) supporting international expansion.", linkLabel: "teampoland.eu", linkUrl: "https://teampoland.eu/" },
        { title: "Financing Institutions", desc: "Engagement with institutions like BGK — development loans and buyer credit — and KUKE export credit insurance, alongside other support instruments.", linkLabel: "bgk.pl", linkUrl: "https://www.bgk.pl" },
        { title: "TOREN PATH", desc: "Our financing-path partner within the Arthur Toren group: instrument mapping, project structuring and applications handled end to end.", linkLabel: "path.com.pl", linkUrl: "https://path.com.pl" },
        { title: "Special Economic Zones", desc: "Assembly inside Kenyan SEZs saves ~25% on import duties and VAT — capital rotated straight back into inventory. Kenyan-assembled EVs built to European standards export duty-free to the EU under EPAs, on a phased path to 'Kenyan Made' certification." },
      ],
      faqEyebrow: "Financing FAQ",
      faq: [
        { q: "How does KUKE insurance help my deployment?", a: "KUKE insures the credit behind Polish equipment exports. For a MargTor program this means the financing bank's risk is covered — including under policies like 'Polisa bez Granic' — which unlocks credit that would otherwise be unavailable for an African deployment." },
        { q: "How does BGK buyer credit work?", a: "Under BGK's buyer credit, the bank finances the foreign buyer of Polish capital goods. Your organization receives a long-term loan to pay for the program, repaid over years — with the Polish engineering and equipment content of our delivery as the qualifying basis." },
        { q: "Can KUKE and BGK be combined?", a: "Yes — that is the standard structure: BGK provides the financing, KUKE insures it. TOREN PATH maps the right instrument mix for your project and handles the application process end to end." },
        { q: "What does MargTor prepare for the application?", a: "A bankable documentation pack: feasibility study, TCO-versus-petrol model, cash-flow forecast, risk register and implementation schedule — ready for credit committees and grant programs." },
        { q: "How do riders or fleet operators finance the vehicles?", a: "Through direct APIs with local banks (e.g., KCB, Equity): loan repayment is linked to the vehicle's telematics, which de-risks lending. Stress tests show the swap-network model returns investment in 8–10 months, and the charging network becomes self-sustaining at roughly 300 active bikes." },
      ],
      eventsEyebrow: "Upcoming Delegations",
      joined: "firms joined",
      liveBadge: "Live · path.com.pl",
      eventsNote: "All delegations are organized with full travel assistance by TOREN PATH — stands, logistics, translation and matched B2B meetings.",
      eventsCta: "Join a Delegation",
      events: [
        { name: "Nairobi International Trade Fair 2026", dates: "29 SEP – 5 OCT 2026", venue: "Jamhuri Park, Nairobi", desc: "East Africa's biggest trade fair — innovation and technology in agriculture and commerce.", url: "https://ask.co.ke/nairobi-international-tradefair/" },
        { name: "Uganda–EU Business Forum 2026", dates: "20–21 OCT 2026", venue: "Serena Hotel, Kampala", desc: "Investment-ready renewable energy projects, B2B matchmaking and EU financing institutions.", url: "https://ugeubusinesshub.com/forum-2026/" },
        { name: "27th Autoexpo Tanzania 2026", dates: "18–20 NOV 2026", venue: "Diamond Jubilee Expo Centre, Dar es Salaam", desc: "East Africa's largest automotive trade show — parts, accessories and equipment.", url: "https://www.expogr.com/tanzania/autoexpo/" },
        { name: "28th Autoexpo Kenya 2027", dates: "14–16 JUL 2027", venue: "Carnivore, Nairobi", desc: "Kenya's flagship automotive expo — parts, accessories and commercial vehicles.", url: "https://www.expogr.com/kenyaauto/" },
      ],
    },
    tco: {
      eyebrow: "Fleet Economics",
      title: "Numbers a credit committee can audit.",
      desc: "Verifiable models — every assumption stated, arithmetic open, inputs you can change yourself.",
      integrationEyebrow: "Boda-Boda Fleet Integration",
      metrics: [
        { val: "650 kg", label: "Max Payload (3W Cargo)" },
        { val: "30°", label: "Loaded Gradeability" },
        { val: "<45 s", label: "Energy Turnaround" },
        { val: "18–20 h", label: "Daily Availability" },
        { val: "130–150 km", label: "3W Range / Charge" },
        { val: "5 yr", label: "Warranty · 100k km" },
      ],
      integrationNote: "Every unit ships with FarDriver-embedded IoT — live CAN diagnostics, geo-fencing, remote disable — plus fleet APIs compatible with existing management software and fintech rails (KCB, Equity).",
      tableEyebrow: "TCO — per motorcycle, 5-year boda lifecycle",
      assumption: "Assumptions: ~150 km/day, 360 riding days/yr, petrol ≈ 180 KES/L, swap ≈ 30 KES/pack, bare vehicle at ICE price parity, battery as a service.",
      colA: "ICE Motorcycle",
      colB: "MargTor Electric",
      rows: [
        ["Energy cost / day", "≈ 600 KES fuel", "≈ 485 KES (60 KES for 2 swaps + 425 KES BaaS)"],
        ["Operating cost / day", "≈ $10.03", "≈ $6.17"],
        ["Maintenance profile", "Engine, oil, chain, clutch", "Hub/mid motor — minimal wear parts"],
        ["Rider daily saving", "—", "38.5%"],
        ["5-year operating delta", "Baseline", "≈ $6,900 saved / bike"],
        ["Battery risk", "n/a", "MargTor's — Battery-as-a-Service"],
        ["Downtime", "Fuel queues, workshop days", "<45 s swaps, 24/7 cabinets"],
      ],
      footnote: "Model assumptions, not audited fleet data · FX ≈ 129 KES/USD · full model shared in the partner process",
      calc: {
        eyebrow: "Live TCO Calculator",
        desc: "Drag the sliders — savings update instantly. Same model as the table above.",
        kmLabel: "Distance per bike / day",
        fuelLabel: "Petrol price",
        fleetLabel: "Fleet size",
        fleetUnit: "bikes",
        outDaily: "Saved per bike / day",
        outPct: "Rider saving",
        outMonth: "Fleet saving / month",
        out5y: "Fleet saving / 5 years",
        constants: "Constants: 45 km/L · 30 KES per swap (≈75 km) · BaaS 425 KES/bike/day · EV service ≈ 45% of ICE",
      },
        share: {
          eyebrow: "Share your result",
          desc: "A card with your numbers — the link preview on LinkedIn and WhatsApp renders exactly these values. Move the sliders and the card updates itself.",
          previewTag: "Link preview", linkedin: "Share on LinkedIn", copy: "Copy post text", copied: "Copied", copiedTitle: "Post copied",
          copiedBody: "Paste it into LinkedIn — the link unfurls into your savings card.", copyFailed: "Could not copy — please select the text manually.",
          download: "Download PNG", alt: "MargTor TCO savings card with my assumptions",
          post: "I ran the numbers for a fleet of {fleet} electric motorcycles in Kenya ({km} km/day, petrol at {fuel} KES/L):\n\n• {daily} KES saved per bike per day\n• {pct}% lower cost for the rider\n• {month} KES per month across the fleet\n• {five} over 5 years\n\nModel: Battery-as-a-Service, 45 km/L, EV service ≈ 45% of ICE. MargTor Ltd. TCO calculator:",
          hashtags: "#ElectricMobility #EMobility #Africa #Kenya #BatterySwap #FleetElectrification #TCO #MargTor",
        },
      uwEyebrow: "Underwriting & Financing",
      uwCards: [
        { title: "Telematics-Secured Credit", desc: "Repayment is linked to the vehicle: remote disable and geo-fencing act as digital collateral. Comparable telematics-secured portfolios in East Africa report collection rates around 90% (industry reports); actual results depend on the lender and market." },
        { title: "Micro-Financing Structures", desc: "Daily and weekly micropayments matched to rider cash flow, via mobile-money and bank APIs — underwriting built on telematics earnings data, not paperwork." },
        { title: "Lease-to-Own for Fleets", desc: "Fleet buyers lease bare vehicles with Battery-as-a-Service: battery risk stays with MargTor, the vehicle amortizes over 3–5 years, ownership transfers at term." },
        { title: "Institutional Capital Layer", desc: "Program-level CapEx is structured with BGK buyer credit, KUKE insurance and Team Poland instruments (see Financing). Vehicle-level lending stays local." },
      ],
    },
    group: {
      eyebrow: "The Arthur Toren Group",
      title: "One holding. Several high-value businesses. One gateway to East Africa.",
      desc: "MargTor is the engineering company of the Arthur Toren group — a Belfast- and Nairobi-based holding that has been bringing European businesses into Kenya and Tanzania since 2019 and ties together e-mobility, battery manufacturing, fleet software, trade financing and vehicle design. If your interest in East Africa goes beyond EVs, this is the contact to make.",
      holding: "Holding", companiesLabel: "Group companies & partners",
      contactEyebrow: "A valuable contact for anyone interested in East Africa",
      contactTitle: "Market entry, company registration, special economic zones, work permits, local partners, expansion financing.",
      contactDesc: "The Arthur Toren Associates team has assisted 20+ EU companies in Kenya and Tanzania. The first consultation is free.",
      cta: "Visit arthurtoren.co.uk", ctaAlt: "UK site",
      supportersEyebrow: "Supporting partners",
      supportersTitle: "Principles we build on.",
      supportersDesc: "Two Kenyan organisations whose missions shape how MargTor deploys: who finances the rider, who maintains the fleet, and how a swap hub serves a community rather than just a road.",
      supporters: [
        { name: "Joyful Women Organization (JoyWo)", url: "https://joywo.org", tag: "Women's economic empowerment · Table Banking", mission: "250,000+ women across 44 Kenyan counties pooling savings and credit at the table — radical transparency, collective accountability and dividends shared by the group. Founded by H.E. Mama Rachel Ruto.", value: "JoyWo's chama discipline is the template for how MargTor finances riders: group guarantees, daily micro-repayments and women-led cooperatives as owners of swap hubs. It keeps our Battery-as-a-Service bankable at the grassroots." },
        { name: "SMACHS Foundation", url: "https://smachs.foundation", tag: "Youth-led climate action & climate-smart agriculture", mission: "A youth-led Kenyan non-profit tackling climate change and food insecurity through tree planting, model farms and youth agribusiness — action, education and collaboration.", value: "SMACHS gives MargTor a pipeline of young technicians and a yardstick: every solar swap hub must cut diesel, power a farm or a cold-room, and employ local youth. Their principles keep our growth measured in livelihoods, not only in vehicles." },
      ],
      companies: [
        { name: "Arthur Toren Associates", url: "https://arthurtoren.co.uk", role: "Holding · East Africa market-entry consultancy (est. 2019; Belfast · Nairobi)", holding: true },
        { name: "MargTor Ltd.", url: "https://margtor.africa", role: "EV engineering partner — 2W/3W fleets, boats, swap & solar infrastructure (Nairobi)" },
        { name: "electro.technology", url: "https://electro.technology", role: "R&D, motor control & fleet software (Poland)" },
        { name: "Hadron Energy", url: "https://hadronenergy.pl", role: "Battery & energy-storage manufacturing (Poland) · 35% held by Arthur Toren Associates, 65% by a Singapore-based company" },
        { name: "Amperi", url: "https://amperi.eu", role: "Electric motorcycle platforms (Poland)" },
        { name: "TOREN PATH", url: "https://path.com.pl", role: "Polish–African Trade Holding · financing paths, delegations" },
        { name: "Ultre Mobility", url: "https://ultre.city", role: "Ultralight EV design studio" },
        { name: "UBBA tech", url: "/knowledge/polish-sez-kenya-ev-manufacturing", role: "Manufacturing partner · e-motos & tuk-tuks in the Polish SEZ, Kenya", internal: true },
      ],
    },
    press: {
      eyebrow: "In the press", outlet: "XYZ · xyz.pl",
      headline: "The first year of the Polish economic zone in Kenya. Poles are building tuk-tuks",
      desc: "2025 was the first full year of the Polish special economic zone in Kenya — the only one in the country dedicated to investors from a single nation. Three Polish companies inside, more in talks; UBBA tech builds e-motos and tuk-tuks with Polish controllers, BMS and IoT for export to Tanzania and DR Congo, with electro.technology and VGK among the suppliers.",
      facts: [
        { val: "3", label: "Polish companies in the zone" }, { val: "750+", label: "motorcycles for DRC mines (2025)" },
        { val: "200+", label: "for a Tanzanian distributor" }, { val: "1", label: "the only single-nation SEZ in Kenya" },
      ],
      cta: "Our analysis in the Knowledge Hub", source: "Read the source on xyz.pl", attribution: "Figures as reported by XYZ (xyz.pl).",
    },
    capital: {
      eyebrow: "Technology & Battery Partners",
      title: "The battery comes from partners we know by name — not from a catalogue.",
      partnersLabel: "Design & Technology Ecosystem",
      designLine: "New vehicle design developed with Ultre Mobility — the ultralight EV design studio at ultre.city.",
      partners: [
        { label: "electro.technology", url: "https://electro.technology", role: "R&D & Fleet Control" },
        { label: "amperi.eu", url: "https://amperi.eu", role: "Vehicle Platforms" },
        { label: "hadronenergy.pl", url: "https://hadronenergy.pl", role: "Battery & ESS partner · 35% held by Arthur Toren Associates" },
        { label: "ultre.city", url: "https://ultre.city", role: "Vehicle Design Studio" },
      ],
      desc: "MargTor works directly with Hadron Energy (hadronenergy.pl), its Polish battery and ESS manufacturing partner, in which Arthur Toren Associates holds a 35% minority stake (the majority is held by a Singapore-based company). The partnership gives us a direct cell-to-pack supply line, LFP chemistry tested for tropical climates and full cell provenance — without owning the factory.",
      points: [
        { val: "Direct", label: "Cell-to-pack supply line" },
        { val: "LFP", label: "Tropical-tested chemistry" },
        { val: "35%", label: "Arthur Toren Associates stake in Hadron Energy" },
      ],
    },
    founders: {
      eyebrow: "Engineering Provenance",
      title: "Built by engineers who have shipped at scale.",
      vcard: "Save contact",
      qrHint: "Scan to save contact",
      items: [
        {
          name: "Gurinder Oberoi Singh",
          photo: "/assets/img/founder-gurinder-studio.jpg",
          photoPos: "50% 28%",
          role: "Co-Founder & Chief Executive Officer",
          heritage: "Indian Automotive & EV Veteran",
          experience: "Director, VGK Electric • 30+ yrs automotive • 15+ yrs EV manufacturing",
          bio: "The industrialist behind the KRAZEE e-moto and EZEEGO tricycle series. He has engineered and homologated EV products for 480+ manufacturers across India, secured ARAI certification, and designs supply chains down to container-level packing density. At MargTor he leads industrialization: greenfield assembly, tier-1 sourcing, quality systems and pan-African expansion.",
          stats: ["480+ OEM programs", "ARAI certified · 2022", "140 CKD kits / 40ft FCL"],
          linkedin: "https://linkedin.com/in/gurinder-singh-oberoi-b5357099",
          email: "g.oberoi@margtor.africa",
          vcard: "gurinder-oberoi-singh",
          links: [
            { label: "LinkedIn", url: "https://linkedin.com/in/gurinder-singh-oberoi-b5357099" },
            { label: "VGK Electric · KRAZEE", url: "https://linkedin.com/in/gurinder-singh-oberoi-b5357099" },
          ],
        },
        {
          name: "Gregory Radek",
          photo: "/assets/img/founder-gregory-studio.jpg",
          photoPos: "50% 30%",
          role: "Co-Founder & Chief Technology Officer · East Africa's leading EV 2W/3W expert",
          badge: "Industry expert · Electric 2W & 3W, East Africa",
          linkedin: "https://www.linkedin.com/in/gregradek/",
          email: "g.radek@margtor.africa",
          vcard: "gregory-radek",
          heritage: "Polish Systems & Power Electronics Engineer",
          experience: "CEO, electro.technology since 2019 • Ex-CISCO consultant • 20+ yrs IT systems • 7+ yrs EV",
          bio: "Recognised as the go-to industry expert on electric two- and three-wheelers in East Africa: he has engineered, deployed and financed e-boda and cargo-trike fleets, swap networks and telematics across Kenya and Tanzania, advises operators, lenders and public bodies, and speaks at EVS Kenya and regional e-mobility forums. Built electro.technology into an EV design-and-distribution house behind the Amperi and Newbot brands — including the 2024 Guinness World Record electric motorcycle ride along Poland's borders. Six years leading multicultural expansion consulting at Arthur Toren Associates, building UBBA in Kenya since 2024. At MargTor he architects the connected layer: motor control, battery optimisation, telemetry and fleet management.",
          stats: ["#1 EV 2W/3W expert · East Africa", "Guinness World Record · 2024", "EVS Kenya 2025 speaker", "Amperi & Newbot brands"],
          links: [
            { label: "LinkedIn", url: "https://www.linkedin.com/in/gregradek/" },
            { label: "electro.technology · CEO", url: "https://electro.technology" },
            { label: "Amperi vehicles", url: "https://amperi.eu" },
            { label: "AmperCity · Amperi fleets in Europe", url: "https://ampercity.pl" },
            { label: "Hadron Energy · battery partner", url: "https://hadronenergy.pl" },
            { label: "Arthur Toren · Founder", url: "https://arthurtoren.co.uk" },
            { label: "EU–Africa Business Forum", url: "https://community.eu-africabusinessforum.eu/c/eu-africa-businessforum-facility/person/Q29tbXVuaXR5UHJvZmlsZV80MjI4MDc5Ng==" },
          ],
        },
      ],
    },
    amperi: {
      eyebrow: "Proven in Europe · Amperi by electro.technology",
      title: "Reliability where the business depends on it.",
      desc: "Before East Africa, the same engineering team proved itself on European streets. Amperi electric motorcycles — designed and distributed by Gregory Radek's electro.technology — run daily in sharing fleets, delivery and rental businesses across Poland, Spain, Croatia and other markets, where a vehicle that stops means revenue that stops.",
      proof: [
        { name: "AmperCity", url: "https://ampercity.pl", role: "Poland · electric scooter sharing on Amperi vehicles", desc: "A city sharing fleet that lives or dies on uptime: thousands of rides a month, outdoor charging, all-weather use — and Amperi hardware keeping availability high season after season." },
        { name: "eFun Motos", url: "https://www.efunmotos.com/", role: "Spain · distributor", desc: "Amperi/eFun models sold and serviced across the Spanish market for commuters, delivery riders and rental operators." },
        { name: "Citycoco Croatia", url: "https://citycoco.hr/oznaka-proizvoda/efun/", role: "Croatia · distributor", desc: "Coastal rental and tourism fleets — high daily mileage, salt air and summer heat, the closest European proxy for Mombasa or Dar es Salaam." },
        { name: "E-gazia", url: "https://www.e-gazia.com/", role: "Greece · importer & dealer network", desc: "Electric two-wheelers for private riders, professionals and delivery companies across Greece — eFun scooters with a nationwide sales and service network." },
        { name: "Electrons.gr", url: "https://electrons.gr/", role: "Greece · batteries & EV specialist", desc: "Battery engineering and EV retail house carrying eFun vehicles — the kind of partner that measures a scooter by its pack life, not its brochure." },
        { name: "RIEDIS Electric", url: "https://riedis-electric.com/", role: "Lithuania · electric transport experts", desc: "Baltic distributor of electric bikes, scooters and three-wheelers; eFun models serve commuters through long, cold Northern winters." },
        { name: "escooter.com.cy", url: "https://escooter.com.cy/", role: "Cyprus · dealer", desc: "Island fleets in year-round heat and stop-and-go traffic — where motor and controller thermal design is tested every single day." },
        { name: "Amperi", url: "https://amperi.eu", role: "Poland · design & engineering HQ (electro.technology)", desc: "Where the platforms, controllers and BMS behind every dealer above are designed, type-approved and supported — and where MargTor's East African platforms inherit their engineering." },
      ],
      links: [
        { label: "amperi.eu", url: "https://amperi.eu" },
        { label: "electro.technology", url: "https://electro.technology" },
      ],
      note: "What held up in Warsaw, Madrid, Athens, Vilnius and Nicosia is what we specify for Nairobi: the controller, BMS and telemetry stack carried over into MargTor's reference platforms.",
      marketsLabel: "Sales & service network",
    },
    china: {
      eyebrow: "中国伙伴 · Partner for Chinese companies",
      title: "Your trusted local partner for expansion into Africa.",
      desc: "MargTor already works with Chinese manufacturers in Kenya — importing, homologating, assembling and providing after-sales service for their vehicles and batteries. Our founders are Polish and Indian engineers (Radek · Singh) with a long record of keeping their word; through Hadron Energy — our battery partner, 35% held by Arthur Toren Associates — we have been a trusted counterpart of Chinese battery suppliers in Europe for years. We know the local arrangements, the authorities and the customers — and we stay for the long term.",
      points: [
        { title: "Relationships first, then contracts", desc: "We build trust the way our Chinese partners do: in person, over time, with introductions to the right people. One stable counterpart, not a rotating sales team." },
        { title: "Proven with Chinese partners in Europe", desc: "Hadron Energy (hadronenergy.pl) has sourced cells and co-engineered packs with Chinese manufacturers since 2019 — audited factories, honoured payment terms, shared roadmaps." },
        { title: "Already serving Chinese brands in Kenya", desc: "Import, KEBS/NTSA homologation, SEZ assembly, dealer onboarding, spare-parts stock and warranty service — handled locally by MargTor engineers." },
        { title: "Local knowledge you cannot ship", desc: "Nairobi, Dar es Salaam, Kinshasa: regulators, SACCOs, financiers, mobile-money rails and duty structures. We translate the market, not just the language." },
        { title: "After-sales that protects your brand", desc: "Trained technicians, telematics diagnostics and a 48-hour response standard — because in Africa a vehicle that stops is a brand that stops." },
        { title: "Long-term, face-to-face", desc: "Equity or retainer partnerships of three years and more; we host delegations in Nairobi and visit Shenzhen, Wuxi and Chongqing regularly." },
      ],
      wechatLabel: "WeChat",
      wechat: "arthurtoren",
      wechatHint: "Add us on WeChat — we reply in Chinese and English.",
      cta: "Book a discovery call",
      cta2: "Hadron Energy — our Chinese-partner track record",
      trust: ["Polish & Indian founders", "Since 2019 with Chinese suppliers", "Nairobi · Dar es Salaam · Kinshasa", "After-sales in Kenya today"],
    },
    gwr: {
      eyebrow: "Proof in the Field",
      title: "Guinness World Record, 2024.",
      desc: "The first long-distance electric motorcycle ride along Poland's entire border — on Amperi hardware engineered within our ecosystem. Range, charging resilience and endurance proven in public, not on paper.",
      chip: "Ridden on Amperi hardware",
      caption: "Amperi HQ, Poland — the 2024 record ride crew",
      mototrip: "Earlier, in July 2023, Amperi-designed motorcycles led the entire Electric MotoTrip — the Polish Record ride around the whole country's border zone, certified by Biuro Rekordów.",
      mototripCta: "Biuro Rekordów — Electric MotoTrip",
      stats: [
        { val: "1st", label: "Ride of Its Kind" },
        { val: "2024", label: "Guinness World Record" },
        { val: "PL", label: "Full Border Loop" },
      ],
    },
    partners: {
      eyebrow: "Partner Program",
      title: "How companies engage MargTor, step by step.",
      desc: "A structured engagement model — from the first call to a fleet that runs on sunshine. You bring the operation; we bring the engineering.",
      stepsEyebrow: "The Engagement Path",
      steps: [
        { num: "01", title: "Discovery Call", desc: "A 45-minute call with our engineering leads. We map your duty cycle: routes, loads, waters, grid access and solar potential. You get an honest feasibility read within 48 hours." },
        { num: "02", title: "Technical Audit", desc: "On-site or remote assessment — fleet data, energy infrastructure, terrain and climate constraints. Output: a feasibility memo with risks and opportunities." },
        { num: "03", title: "Engineered Proposal", desc: "A complete program specification: platform selection, charging or swap topology, ESS sizing, telematics stack, timeline and budget ranges. No guesswork." },
        { num: "04", title: "Pilot Deployment", desc: "A controlled pilot — typically 5–10 units — with a full telemetry baseline, driver and technician training, and measured performance against your current fleet." },
        { num: "05", title: "Scale-Up", desc: "Full rollout with local assembly or CKD kits where viable, white-label branding under your name, and battery supply secured with our partner Hadron Energy." },
        { num: "06", title: "Operate & Support", desc: "We stay on as your technical partner: parts pipeline, remote fleet monitoring, maintenance training and continuous engineering improvement." },
      ],
      audiencesEyebrow: "Who Engages Us",
      audiencesTitle: "Built for organizations, not showrooms.",
      audiences: [
        { title: "Fleet & Logistics Operators", desc: "Delivery, boda and cargo fleets replacing petrol with engineered EV programs." },
        { title: "Fishing & Tourism Cooperatives", desc: "Electric conversion programs for boats on lakes and coastal waters." },
        { title: "Energy & Infrastructure Developers", desc: "Charging, swap and ESS projects with solar micro-grid integration." },
        { title: "Government & Education", desc: "County fleets, vocational EV training labs and public transport pilots." },
        { title: "Investors & Industrial Groups", desc: "White-label vehicle programs and local assembly ventures." },
      ],
      ctaTitle: "Ready to scope your program?",
      ctaDesc: "Start with a discovery call — or send your technical brief through the enquiry form.",
      cta: "Start the Conversation",
      note: "MargTor is the engineering partner. Vehicle sales run through a separate distribution entity.",
      engEyebrow: "Long-Term Engagement",
      engTitle: "We stay for years, not deliveries.",
      engDesc: "Every deployment is a 3+ year partnership. We lead the initial stages — then keep engineering your success.",
      services: [
        "Program leadership through the initial stages",
        "Rider & technician training",
        "Sourcing oversight — from China to site",
        "Supplier qualification & oversight",
        "New product development for your market",
        "Technology advisory as options evolve",
      ],
      compEyebrow: "How We're Compensated",
      compTitle: "Equity or retainer — aligned with your outcome.",
      compDesc: "For new deployments we ideally take equity in the venture we help build. For established operators, a long-term technical retainer. Either way: we win when your fleet wins.",
    },
    pilot: {
      eyebrow: "Reference Deployment · Projected Economics",
      title: "A Tanzanian customer project — year-1 economics as projected in the customer's business plan.",
      stats: [
        { val: "$542K", label: "Phase-1 CapEx (planned)" },
        { val: "196", label: "Vehicles · 140 2W + 56 3W (phase 1)" },
        { val: "12", label: "Swap Cabinets" },
        { val: "38.5%", label: "Rider Daily Savings (modelled)" },
        { val: "$1.15M", label: "Year-1 Net Profit (projected)" },
        { val: "45.5%", label: "Net Margin (projected)" },
      ],
      note: "Projections from the customer's business plan, engineered with MargTor — not audited operating results. Bare bikes sell at petrol parity; the battery stays with the operator as a service (BaaS) — riders cut daily energy and maintenance cost by 38.5% in the model. Supply chain: China → East Africa in 45–55 days. Year-3 growth model: ~23,000 active bikes (projection). The 196-vehicle phase 1 is a full deployment; our engagement path starts smaller, with a 5–10-unit pilot.",
      cta: "See the Engagement Model",
      download: "Download Pilot Strategy (PDF)",
      share: {
        eyebrow: "Share these numbers",
        desc: "One tap posts the deployment card with the key figures to your network — the link preview renders this exact card. Copy the ready-made post text to add your own take.",
        previewTag: "Link preview",
        cardTitle: "Reference Deployment — Projected Economics — MargTor Ltd.",
        cardAlt: "MargTor reference deployment card (projected): $542K phase-1 CapEx, 196 vehicles, 12 swap cabinets, 38.5% modelled rider daily savings, $1.15M projected year-1 net profit, 45.5% projected net margin.",
        linkedin: "Share on LinkedIn",
        copy: "Copy post text",
        copied: "Copied",
        copiedTitle: "Post copied",
        copiedBody: "Paste it into LinkedIn — the link unfurls into the deployment card.",
        copyFailed: "Could not copy — please select the text manually.",
        more: "More",
        post: "Anatomy of an electric fleet deployment — projected year-1 economics (Tanzanian customer business plan, engineered with MargTor Ltd.):\n\n• $542K phase-1 CapEx\n• 196 vehicles — 140 e-motos + 56 three-wheelers\n• 12 battery swap cabinets\n• 38.5% modelled daily savings for riders\n• $1.15M projected year-1 net profit at 45.5% margin\n\nProjections, not audited results. Battery-as-a-Service keeps the battery risk with the operator, not the rider. This is what a bankable EV deployment plan in East Africa looks like.",
        hashtags: "#ElectricMobility #EMobility #Africa #BatterySwap #FleetElectrification #Kenya #Tanzania #MargTor",
      },
    },
    contact: {
      eyebrow: "Request a Specification",
      title: "Let's deploy electric mobility — together.",
      desc: "We partner with local companies, cooperatives, investor groups, educational institutions and government initiatives to roll out EV fleets, electric boats and solar charging — ending dependence on petrol and diesel. Enquiries are answered within 48 hours.",
      name: "Full Name",
      company: "Organization / Company",
      email: "Official Email",
      phone: "Phone / WhatsApp",
      country: "Country of Operation",
      solution: "Solution Interest",
      fleet: "Estimated Fleet Size / Power Requirement",
      message: "Technical Brief & Requirements",
      submit: "Transmit Enquiry",
      sending: "Transmitting…",
      successTitle: "Enquiry received",
      successBody: "Our engineering desk will respond within 48 hours.",
      errorTitle: "Transmission failed",
      errorBody: "Please retry — or reach us directly by email.",
      countries: ["Kenya", "DR Congo", "Tanzania", "Uganda", "Rwanda", "Other / International"],
      solutions: ["EV 2W/3W Fleet Engineering", "Electric Boats (Fishing & Tourism)", "Charging & Swap Infrastructure", "ESS / Energy Storage", "White Label Manufacturing", "Technical Partnership / Investment"],
      phonesLabel: "Direct Lines",
      phones: ["+254 719 180 236", "+254 708 189 175"],
      emailLabel: "E-mail",
      contactEmail: "office@margtor.africa",
      brief: "Download Partnership Brief (PDF)",
      briefFile: "/assets/MargTor-Partnership-Brief.pdf",
    },
    footer: {
      press: "Press kit",
      tagline: "Precision electric mobility, engineered for Africa.",
      offices: "Nairobi • Kinshasa • Dar es Salaam",
      legal: "MargTor Ltd. — Registered in Kenya, founded 2024.",
      groupPre: "Part of the",
      groupLink: "Arthur Toren group",
      groupSite: "arthurtoren.co.uk",
      groupDesc: "A holding spanning several high-value businesses in East Africa — the first contact for anyone interested in the region.",
      nav: "Index",
      contact: "Channel",
      rights: "All rights reserved.",
      iso: "ISO-aligned safety & quality assurance",
      credits: "Street photography: Wikimedia Commons contributors (CC BY-SA) · Text & data:",
    },
  },
  sw: {
    "chat": {
      "launcher": "Uliza MargTor",
      "close": "Funga",
      "eyebrow": "Msaidizi wa Kituo cha Maarifa",
      "title": "Uliza MargTor",
      "welcome": "Uliza chochote kuhusu kundi la magari ya umeme, kubadilisha betri, TCO, ufadhili au mfumo wa ushirikiano wa MargTor. Majibu yanatoka kwenye Kituo chetu cha Maarifa.",
      "suggestions": [
        "Kubadilisha betri hufanyaje kazi kwa boda-boda?",
        "Boda-boda ya umeme huokoa kiasi gani kwa siku ikilinganishwa na petroli?",
        "BGK/KUKE inaweza kufadhili vipi mtandao wa kubadilisha betri?"
      ],
      "placeholder": "Andika swali lako…",
      "send": "Tuma",
      "typing": "Inafikiri…",
      "contactCta": "Zungumza na timu",
      "error": "Msaidizi hapatikani kwa sasa — timu yetu itakujibu moja kwa moja kwa furaha.",
      "disclaimer": "Majibu ya AI kutoka kwenye maudhui ya margtor.africa · hakuna bei · yanaweza yasiwe kamili"
    },
    "manifesto": {
      "eyebrow": "Falsafa ya MargTor",
      "title": "Hatuagizi magari. Tunayahandisi kwa mazingira halisi ya matumizi.",
      "chapters": [
        {
          "num": "01",
          "title": "Yaliyobuniwa kwa mazingira ya ndani",
          "desc": "Magari ya kuagizwa hushindwa kwenye barabara mbovu na maeneo yenye unyevu mwingi. Tunabuni chassis, mifumo ya udhibiti wa joto na suspension mahsusi kwa matumizi ya Afrika Mashariki na ya Kati."
        },
        {
          "num": "02",
          "title": "DNA ya uhandisi wa mabara matatu",
          "desc": "Ilianzishwa mwaka 2024, ikiwa na mizizi katika utengenezaji wa magari wa India na uelektroniki wa nguvu wa EV wa Poland — kupitia Amperi, electro.technology na Hadron Energy."
        },
        {
          "num": "03",
          "title": "Nishati inayobadilishwa kwa urahisi",
          "desc": "Tunaondoa muda wa kusubiri kuchaji kwa waendeshaji wa boda-boda na wavuvi kupitia betri za viwango sanifu na makabati mahiri ya kubadilisha."
        },
        {
          "num": "04",
          "title": "White Label kwa wadau wa ndani",
          "desc": "Mifumo ya EV iliyothibitishwa inayotengenezwa chini ya chapa yako — ili kampuni za ndani, vyama vya ushirika na miradi ya umma viweze kutumia magari ya umeme kwa haraka, kwa msaada wa uhandisi wetu, telematiki na kundi la betri."
        }
      ]
    },
    "booking": {
      "eyebrow": "Simu ya utambuzi",
      "title": "Weka miadi ya simu ya utambuzi ya dakika 45.",
      "desc": "Chagua muda, tuambie kuhusu kundi la magari, ziwa au eneo lako, nasi tutathibitisha kwa barua pepe na mwaliko wa kalenda. Tathmini ya uwezekano ndani ya saa 48 baada ya simu.",
      "tz": "Saa za Nairobi (EAT, UTC+3) · Jumatatu–Ijumaa 10:00–16:00",
      "step1": "1 · Chagua siku",
      "step2": "2 · Chagua muda",
      "step3": "3 · Maelezo yako",
      "name": "Jina kamili",
      "email": "Barua pepe ya kazi",
      "company": "Kampuni / chama",
      "phone": "Simu (hiari)",
      "topic": "Ungependa kujadili nini?",
      "selected": "Umechagua",
      "pickSlot": "Chagua siku na muda kwanza",
      "submit": "Thibitisha miadi",
      "sending": "Inawekwa…",
      "taken": "Muda huo umechukuliwa sasa hivi — tafadhali chagua mwingine.",
      "error": "Imeshindwa kukamilisha miadi. Jaribu tena au tumia fomu ya mawasiliano.",
      "successToast": "Simu ya utambuzi imewekwa",
      "confirmed": "Imewekwa",
      "emailSent": "Uthibitisho na mwaliko wa kalenda umetumwa kwa barua pepe yako.",
      "emailPending": "Miadi yako imehifadhiwa; iongeze kwenye kalenda yako hapa chini.",
      "ics": "Pakua .ics",
      "gcal": "Ongeza kwenye Google Calendar",
      "meet": "Jiunge kupitia Google Meet",
      "meetReady": "Kiungo cha Google Meet kimo kwenye mwaliko.",
      "syncedBadge": "Mwaliko wa Google Meet wa moja kwa moja"
    },
    "partners": {
      "eyebrow": "Mpango wa Ushirikiano",
      "title": "Jinsi kampuni zinavyoshirikiana na MargTor, hatua kwa hatua.",
      "desc": "Muundo wa ushirikiano ulio wazi — kuanzia simu ya kwanza hadi magari yanayotumia nishati ya jua. Wewe lete shughuli; sisi tunaleta uhandisi.",
      "stepsEyebrow": "Njia ya Ushirikiano",
      "steps": [
        {
          "num": "01",
          "title": "Simu ya Utambulisho",
          "desc": "Simu ya dakika 45 na wahandisi wetu. Tunatathmini shughuli yako: njia, mizigo, maji, gridi na uwezo wa nishati ya jua. Unapata jibu la uwezekano ndani ya saa 48."
        },
        {
          "num": "02",
          "title": "Ukaguzi wa Kiufundi",
          "desc": "Tathmini ya kwenye eneo au kwa mbali — data za magari, miundombinu ya nishati, ardhi na hali ya hewa. Matokeo: ripoti ya uwezekano yenye hatari na fursa."
        },
        {
          "num": "03",
          "title": "Pendekezo la Uhandisi",
          "desc": "Maelezo kamili ya programu: uteuzi wa mifumo, uchaji au kubadilisha betri, ukubwa wa ESS, mfumo wa telematiki, ratiba na bajeti. Bila kubahatisha."
        },
        {
          "num": "04",
          "title": "Mradi wa Majaribio",
          "desc": "Majaribio ya vitengo 5–10 — na telematiki kamili, mafunzo ya madereva na mafundi, na kulinganisha na magari yako ya sasa."
        },
        {
          "num": "05",
          "title": "Upanuzi",
          "desc": "Utekelezaji kamili na uunganishaji wa ndani au vifurushi vya CKD inapowezekana, chapa yako mwenyewe, na usambazaji wa betri kwa kundi la magari lenye mtaji."
        },
        {
          "num": "06",
          "title": "Uendeshaji na Msaada",
          "desc": "Tunabaki kuwa mshirika wako wa kiufundi: vipuri, ufuatiliaji wa mbali, mafunzo ya matengenezo na maboresho endelevu."
        }
      ],
      "audiencesEyebrow": "Nani Tunashirikiana Naye",
      "audiencesTitle": "Imejengwa kwa mashirika, si maduka.",
      "audiences": [
        {
          "title": "Waendeshaji wa Kundi la Magari na Logistiki",
          "desc": "Makundi ya magari ya usafirishaji, boda-boda na mizigo yanayobadilisha petroli kwa programu za EV."
        },
        {
          "title": "Vyama vya Uvuvi na Utalii",
          "desc": "Programu za kubadili boti za maziwa na pwani zitumie umeme."
        },
        {
          "title": "Watengenezaji wa Nishati",
          "desc": "Miradi ya uchaji, kubadilisha betri na ESS pamoja na ujumuishaji wa sola."
        },
        {
          "title": "Serikali na Elimu",
          "desc": "Makundi ya magari ya kaunti, maabara za mafunzo ya EV na majaribio ya usafiri wa umma."
        },
        {
          "title": "Wawekezaji na Makundi ya Viwanda",
          "desc": "Programu za white-label na miradi ya uunganishaji wa ndani."
        }
      ],
      "ctaTitle": "Uko tayari kupanga programu yako?",
      "ctaDesc": "Anza na simu ya utambulisho — au tuma maelezo yako ya kiufundi kupitia fomu.",
      "cta": "Anza Mazungumzo",
      "note": "MargTor ni mshirika wa uhandisi. Mauzo ya magari hufanywa na shirika tofauti la usambazaji.",
      "engEyebrow": "Ushirikiano wa Muda Mrefu",
      "engTitle": "Tunabaki kwa miaka, si kwa makabidhiano tu.",
      "engDesc": "Kila utekelezaji ni ushirikiano wa miaka 3+. Tunaongoza hatua za mwanzo — kisha tunaendelea kuhandisi mafanikio yako.",
      "services": [
        "Uongozi wa programu katika hatua za mwanzo",
        "Mafunzo ya madereva na mafundi",
        "Usimamizi wa ugavi — kutoka China hadi eneo",
        "Tathmini na usimamizi wa wasambazaji",
        "Uendelezaji wa bidhaa mpya kwa soko lako",
        "Ushauri kuhusu mabadiliko ya teknolojia"
      ],
      "compEyebrow": "Jinsi Tunavyolipwa",
      "compTitle": "Hisa au retainer — tukioanisha malipo yetu na matokeo yako.",
      "compDesc": "Kwa miradi mipya, tunapendelea hisa katika biashara tunayojenga pamoja. Kwa waendeshaji walio imara, retainer ya kiufundi ya muda mrefu. Kwa vyovyote vile: tunashinda kundi la magari lako likishinda."
    },
    "tco": {
      "eyebrow": "Uchumi wa Kundi la magari",
      "title": "Takwimu ambazo kamati ya mikopo inaweza kukagua.",
      "desc": "Mifano inayoweza kukaguliwa — kila kigezo kimewekwa wazi, hesabu ziko wazi, na unaweza kubadilisha vigezo mwenyewe.",
      "integrationEyebrow": "Ujumuishaji wa Makundi ya magari ya Boda-Boda",
      "metrics": [
        {
          "val": "650 kg",
          "label": "Mzigo wa juu (3W)"
        },
        {
          "val": "30°",
          "label": "Upandaji wa mlima ukiwa na mzigo"
        },
        {
          "val": "<45 s",
          "label": "Muda wa kubadilisha betri"
        },
        {
          "val": "18–20 h",
          "label": "Upatikanaji kwa siku"
        },
        {
          "val": "130–150 km",
          "label": "Masafa ya 3W / chaji moja"
        },
        {
          "val": "Miaka 5",
          "label": "Dhamana · km 100k"
        }
      ],
      "integrationNote": "Kila gari huja na IoT ya FarDriver — ufuatiliaji wa CAN kwa wakati halisi, geo-fencing, kuzima kwa mbali — pamoja na API za kundi la magari zinazooana na programu zilizopo za usimamizi na mifumo ya kifedha (KCB, Equity).",
      "tableEyebrow": "TCO — kwa pikipiki, mzunguko wa miaka 5 wa boda-boda",
      "assumption": "Makadirio: ~150 km/siku, siku 360 za kazi/mwaka, petroli ≈ 180 KES/L, swap ≈ 30 KES/paki, gari bila betri kwa bei sawa na ICE, betri kama huduma.",
      "colA": "Pikipiki ya ICE",
      "colB": "Umeme wa MargTor",
      "rows": [
        [
          "Gharama ya nishati / siku",
          "≈ 260 KES mafuta",
          "≈ 60 KES (swap 2)"
        ],
        [
          "Gharama ya uendeshaji / siku",
          "≈ $10.03",
          "≈ $6.17"
        ],
        [
          "Matengenezo",
          "Injini, mafuta, cheni, klachi",
          "Hub/mid-drive — sehemu chache"
        ],
        [
          "Akiba ya dereva / siku",
          "—",
          "38.5%"
        ],
        [
          "Tofauti ya miaka 5",
          "Msingi",
          "≈ $6,900 / pikipiki"
        ],
        [
          "Hatari ya betri",
          "—",
          "Ya MargTor — BaaS"
        ],
        [
          "Urahisi wa uendeshaji",
          "Foleni za mafuta, siku za gereji",
          "Swap <45 s, makabati 24/7"
        ]
      ],
      "footnote": "Telematiki hai ya mradi · FX ≈ 129 KES/USD · mfano kamili hutolewa katika mchakato wa ushirikiano",
      "calc": {
        "eyebrow": "Kikokotoo cha TCO",
        "desc": "Sogeza vitelezi — akiba hujisasisha papo hapo. Mfano huohuo wa jedwali hapo juu.",
        "kmLabel": "Umbali kwa pikipiki / siku",
        "fuelLabel": "Bei ya petroli",
        "fleetLabel": "Ukubwa wa kundi la magari",
        "fleetUnit": "pikipiki",
        "outDaily": "Akiba kwa pikipiki / siku",
        "outPct": "Akiba ya dereva",
        "outMonth": "Akiba ya kundi la magari / mwezi",
        "out5y": "Akiba ya kundi la magari / miaka 5",
        "constants": "Vigezo: 45 km/L · 30 KES kwa swap (≈75 km) · BaaS 425 KES/pikipiki/siku · huduma ya EV ≈ 45% ya ICE"
      },
      "share": {
        "eyebrow": "Shiriki matokeo yako",
        "desc": "Kadi yenye takwimu zako — onyesho la kiungo kwenye LinkedIn na WhatsApp linaonyesha thamani hizi hizi. Sogeza vitelezi na kadi itajisasisha.",
        "previewTag": "Onyesho la kiungo",
        "linkedin": "Shiriki kwenye LinkedIn",
        "copy": "Nakili maandishi ya chapisho",
        "copied": "Imenakiliwa",
        "copiedTitle": "Chapisho limenakiliwa",
        "copiedBody": "Bandika kwenye LinkedIn — kiungo kitafunguka na kuonyesha kadi yako ya akiba.",
        "copyFailed": "Imeshindwa kunakili — chagua maandishi mwenyewe.",
        "download": "Pakua PNG",
        "alt": "Kadi ya akiba ya TCO ya MargTor kulingana na makadirio yangu",
        "post": "Nilihesabu kwa kundi la magari ya pikipiki {fleet} za umeme nchini Kenya (km {km}/siku, petroli KES {fuel}/L):\n\n• KES {daily} zimeokolewa kwa pikipiki kwa siku\n• {pct}% gharama ndogo kwa dereva\n• KES {month} kwa mwezi kwa kundi la magari\n• {five} kwa miaka 5\n\nMtindo: Battery-as-a-Service, 45 km/L, huduma ya EV ≈ 45% ya ICE. Kikokotoo cha TCO cha MargTor Ltd.:",
        "hashtags": "#UsafiriWaUmeme #EMobility #Afrika #Kenya #BatterySwap #FleetElectrification #TCO #MargTor"
      },
      "uwEyebrow": "Udhamini & Ufadhili",
      "uwCards": [
        {
          "title": "Mkopo unaohakikishwa na telematiki",
          "desc": "Malipo huunganishwa na gari: kuzima kwa mbali na geo-fencing hutumika kama dhamana ya kidijitali. Kiwango cha ukusanyaji cha 90% kimeonyeshwa kwa kiwango kikubwa kwa njia hii."
        },
        {
          "title": "Mifumo ya ufadhili mdogo",
          "desc": "Malipo madogo ya kila siku au kila wiki yanayolingana na mapato ya dereva, kupitia mobile money na API za benki — udhamini unaotegemea data za telematiki, si makaratasi."
        },
        {
          "title": "Lease-to-Own kwa Kundi la magari",
          "desc": "Wanunuzi wa kundi la magari hupanga magari mapya na Battery-as-a-Service: hatari ya betri inabaki kwa MargTor, gari hulipiwa kwa miaka 3–5, umiliki huhamishwa mwishoni."
        },
        {
          "title": "Safu ya mtaji wa taasisi",
          "desc": "CapEx ya programu hupangwa kwa mikopo ya BGK, bima ya KUKE na vyombo vya Team Poland (tazama Ufadhili). Mikopo ya magari hubaki ya ndani."
        }
      ]
    },
    "products": {
      "eyebrow": "Wigo wa Uwezo",
      "title": "Mshirika mmoja wa kiufundi kwa wigo mzima wa EV.",
      "desc": "Chagua uwezo uone tunachobuni, tunachounganisha na tunachosambaza.",
      "specLabel": "Vipimo vya Utekelezaji",
      "items": [
        {
          "key": "ev",
          "code": "MGT-EV",
          "name": "Uhandisi wa Magari ya Umeme ya 2W & 3W",
          "desc": "Tunabuni mifumo ya pikipiki nzito za umeme na magari ya magurudumu matatu ya mizigo na abiria: chasisi imara, ujumuishaji wa powertrain, homologation na telematiki ya kundi la magari — tukivisambaza kupitia washirika wetu wa viwandani.",
          "specs": [
            "Umbali hadi km 140",
            "Mzigo wa kg 300–650",
            "Betri yenye IP67",
            "Breki za kurejesha nishati"
          ],
          "img": "/assets/img/boda-karen.jpg"
        },
        {
          "key": "marine",
          "code": "MGT-MR",
          "name": "Injini za Umeme za Boti — Ndani na Nje",
          "desc": "Uendeshaji usio na moshi kwa boti za uvuvi na utalii katika Ziwa Victoria, Ziwa Tanganyika na pwani. Msokoto wa moja kwa moja ndani ya makasha ya aloi yasiyoshika kutu.",
          "specs": [
            "5–80 kW endelevu",
            "Upoezaji wa maji",
            "Hali ya kimya / doria",
            "Imethibitishwa kwa maji ya chumvi na baridi"
          ],
          "img": "/assets/img/marine.jpg"
        },
        {
          "key": "charging",
          "code": "MGT-CH",
          "name": "Uchaji wa AC/DC na Vituo vya Kubadilisha Betri",
          "desc": "Vituo vya uchaji wa haraka vya DC na vituo vya kubadilisha betri vyenye bili za wingu na telematiki.",
          "specs": [
            "Kubadilisha <45 s",
            "Tayari kwa sola",
            "Sloti 12 · 16 kW kwa kabati",
            "Matokeo ya AC/DC"
          ],
          "img": "/assets/img/swap-cabinet.jpg"
        },
        {
          "key": "ess",
          "code": "MGT-ES",
          "name": "ESS — Hifadhi ya Nishati",
          "desc": "Mifumo ya hifadhi ya nishati ya kontena na raki kwa viwanda, microgrids na vituo vya uchaji visivyo kwenye gridi.",
          "specs": [
            "50 kWh – 2 MWh",
            "Kemia ya LFP, mizunguko 4000+",
            "BMS mahiri + udhibiti wa moto",
            "Peak shaving na chelezo"
          ],
          "img": "/assets/img/ess.jpg"
        },
        {
          "key": "iot",
          "code": "MGT-IOT",
          "name": "Telematiki ya Kundi la magari na Udhibiti wa IoT",
          "desc": "Kila mfumo huja na kifaa cha IoT kilichojengewa ndani ya kidhibiti cha injini — ukichezewa, gari huzimika kabisa. Utambuzi wa CAN wa moja kwa moja, kuzima kwa mbali, kufuli ya kuzuia wizi ya reverse, geo-fencing na kupunguza kasi.",
          "specs": [
            "IoT ndani ya kidhibiti cha FarDriver",
            "Utambuzi wa CAN wa moja kwa moja",
            "Kuzima kwa mbali na geo-fencing",
            "4G → 2G → SMS → LoRa",
            "API za kifedha — KCB, Equity"
          ],
          "img": "/assets/img/engineering.jpg"
        },
        {
          "key": "white",
          "code": "MGT-WL",
          "name": "Utengenezaji wa White Label",
          "desc": "Mifumo iliyothibitishwa ya 2W/3W, injini za majini na miundombinu ya kubadilisha betri inayozalishwa chini ya chapa yako — vifurushi vya CKD/SKD, telematiki ya kundi la magari na mafunzo kwa washirika wa utekelezaji.",
          "specs": [
            "Blueprints za mifumo iliyothibitishwa",
            "Chapa yako, uhandisi wetu",
            "API ya telematiki",
            "Mafunzo ya uunganishaji"
          ],
          "img": "/assets/img/assembly-line.png"
        }
      ]
    },
    "financing": {
      "eyebrow": "Ufadhili Kuanzia Ubunifu",
      "title": "Kila programu huja na nyaraka za ufadhili zilizo tayari.",
      "desc": "Programu za MargTor huja na mipango na nyaraka za miradi zinazokubalika na benki kwa maombi ya ufadhili — ili mtaji uwe sehemu ya mpango, si kikwazo.",
      "cards": [
        {
          "title": "Mipango Inayokubalika na Benki",
          "desc": "Tafiti za uwezekano, mifano ya TCO dhidi ya petroli, utabiri wa fedha na rejista za hatari — kwa kiwango kinachokidhi kamati za mikopo kwa kila utekelezaji."
        },
        {
          "title": "Mfumo wa Team Poland",
          "desc": "Tunafanya kazi ndani ya Team Poland — chapa ya pamoja ya taasisi sita za maendeleo za Poland (PFR, BGK, PAIH, KUKE, PARP, ARP) zinazosaidia upanuzi wa kimataifa.",
          "linkLabel": "teampoland.eu",
          "linkUrl": "https://teampoland.eu/"
        },
        {
          "title": "Taasisi za Ufadhili",
          "desc": "Ushirikiano na taasisi kama BGK — mikopo ya maendeleo na mikopo ya mnunuzi — pamoja na bima ya KUKE ya mikopo ya mauzo ya nje, na vyombo vingine vya usaidizi.",
          "linkLabel": "bgk.pl",
          "linkUrl": "https://www.bgk.pl"
        },
        {
          "title": "TOREN PATH",
          "desc": "Mshirika wetu wa njia za ufadhili ndani ya kundi la Arthur Toren: upangaji wa vyombo, uundaji wa miradi na maombi kuanzia mwanzo hadi mwisho.",
          "linkLabel": "path.com.pl",
          "linkUrl": "https://path.com.pl"
        },
        {
          "title": "Maeneo Maalum ya Kiuchumi (SEZ)",
          "desc": "Uunganishaji ndani ya SEZ za Kenya huokoa takriban 25% ya ushuru wa forodha na VAT — mtaji hurudi moja kwa moja kwenye hesabu. Magari ya umeme yaliyokusanywa Kenya kwa viwango vya Ulaya husafirishwa hadi EU bila ushuru wa forodha chini ya EPA, pamoja na njia ya hatua kwa hatua ya cheti cha 'Kenyan Made'."
        }
      ],
      "faqEyebrow": "Maswali ya Ufadhili",
      "faq": [
        {
          "q": "Bima ya KUKE inasaidiaje mradi wangu?",
          "a": "KUKE huhakikisha mkopo unaosindikiza vifaa vya Poland. Kwa programu ya MargTor, hii inamaanisha hatari ya benki inafunikwa — ikijumuisha sera kama 'Polisa bez Granic' — na kufungua mikopo ambayo isingepatikana kwa utekelezaji barani Afrika."
        },
        {
          "q": "Mkopo wa mnunuzi wa BGK unafanyaje kazi?",
          "a": "Katika mkopo wa mnunuzi wa BGK, benki humfadhili mnunuzi wa kigeni wa vifaa vya Poland. Shirika lako hupata mkopo wa muda mrefu wa kulipia programu, kisha hulipa kwa miaka kadhaa — huku uhandisi na vifaa vya Poland katika usambazaji wetu vikiwa msingi wa kustahili."
        },
        {
          "q": "Je, KUKE na BGK zinaweza kuunganishwa?",
          "a": "Ndiyo — huo ndio muundo wa kawaida: BGK hutoa ufadhili, KUKE huihakikisha. TOREN PATH hupanga mchanganyiko sahihi wa vyombo kwa mradi wako na kushughulikia maombi kikamilifu."
        },
        {
          "q": "MargTor huandaa nini kwa maombi?",
          "a": "Kifurushi cha nyaraka zinazokubalika na benki: utafiti wa uwezekano, mfano wa TCO dhidi ya petroli, utabiri wa fedha, rejista ya hatari na ratiba ya utekelezaji — tayari kwa kamati za mikopo na programu za ruzuku."
        },
        {
          "q": "Madereva au waendeshaji wa kundi la magari hufadhili vipi magari?",
          "a": "Kupitia API za moja kwa moja na benki za ndani (mf. KCB, Equity): malipo ya mkopo huunganishwa na telematiki ya gari, na hivyo kupunguza hatari ya ukopeshaji. Majaribio yanaonyesha mfumo wa swap hurudisha uwekezaji ndani ya miezi 8–10, na mtandao wa uchargaji hujikimu kwa pikipiki takriban 300 zinazofanya kazi."
        }
      ],
      "eventsEyebrow": "Ujumbe Ujao",
      "joined": "kampuni zimejiunga",
      "liveBadge": "Moja kwa moja · path.com.pl",
      "eventsNote": "Ujumbe wote huandaliwa na TOREN PATH kwa usaidizi kamili wa safari — mabanda, lojistiki, tafsiri na mikutano ya B2B iliyopangwa.",
      "eventsCta": "Jiunge na Ujumbe",
      "events": [
        {
          "name": "Nairobi International Trade Fair 2026",
          "dates": "29 SEP – 5 OKT 2026",
          "venue": "Jamhuri Park, Nairobi",
          "desc": "Maonyesho makubwa zaidi ya biashara Afrika Mashariki — ubunifu na teknolojia.",
          "url": "https://ask.co.ke/nairobi-international-tradefair/"
        },
        {
          "name": "Uganda–EU Business Forum 2026",
          "dates": "20–21 OKT 2026",
          "venue": "Serena Hotel, Kampala",
          "desc": "Miradi ya nishati mbadala iliyo tayari kwa uwekezaji, B2B na taasisi za ufadhili za EU.",
          "url": "https://ugeubusinesshub.com/forum-2026/"
        },
        {
          "name": "27th Autoexpo Tanzania 2026",
          "dates": "18–20 NOV 2026",
          "venue": "Diamond Jubilee Expo Centre, Dar es Salaam",
          "desc": "Maonyesho makubwa zaidi ya magari Afrika Mashariki — vipuri na vifaa.",
          "url": "https://www.expogr.com/tanzania/autoexpo/"
        },
        {
          "name": "28th Autoexpo Kenya 2027",
          "dates": "14–16 JUL 2027",
          "venue": "Carnivore, Nairobi",
          "desc": "Maonyesho makuu ya magari nchini Kenya — vipuri, vifaa na magari ya kibiashara.",
          "url": "https://www.expogr.com/kenyaauto/"
        }
      ]
    },
    "pilot": {
      "eyebrow": "Muundo wa Mradi wa Majaribio",
      "title": "Mradi wa mteja wa Tanzania — ramani halisi ya utekelezaji.",
      "stats": [
        {
          "val": "$542K",
          "label": "Mtaji wa Kuanzia"
        },
        {
          "val": "196",
          "label": "Magari · 140 2W + 56 3W"
        },
        {
          "val": "12",
          "label": "Makabati ya kubadilisha betri"
        },
        {
          "val": "38.5%",
          "label": "Akiba ya Kila Siku"
        },
        {
          "val": "$1.15M",
          "label": "Faida ya Mwaka wa 1"
        },
        {
          "val": "45.5%",
          "label": "Ukingo wa Faida"
        }
      ],
      "note": "Magari hufadhiliwa kwa gharama sawa na ya petroli; betri hubaki mali yetu kama huduma (BaaS) — madereva hupunguza gharama za nishati na matengenezo kwa 38.5%. Ugavi: China → Afrika Mashariki ndani ya siku 45–55. Mfano wa mwaka wa 3: takriban pikipiki 23,000 zinazofanya kazi.",
      "cta": "Ona Muundo wa Ushirikiano",
      "download": "Pakua Mpango wa Majaribio (PDF)",
      "share": {
        "eyebrow": "Shiriki takwimu hizi",
        "desc": "Bonyeza mara moja kuchapisha kadi ya mradi wa majaribio na takwimu muhimu kwa mtandao wako — hakikisho la kiungo huonyesha kadi hii hasa. Nakili maandishi ya chapisho yaliyo tayari kisha uongeze maoni yako.",
        "previewTag": "Hakikisho la kiungo",
        "cardTitle": "Muundo wa Mradi wa Majaribio — MargTor Ltd.",
        "cardAlt": "Kadi ya uchumi wa mradi wa MargTor: mtaji $542K, magari 196, makabati 12 ya kubadilisha betri, akiba ya kila siku 38.5%, faida ya mwaka wa 1 $1.15M, ukingo wa faida 45.5%.",
        "linkedin": "Shiriki kwenye LinkedIn",
        "copy": "Nakili chapisho",
        "copied": "Imenakiliwa",
        "copiedTitle": "Chapisho limenakiliwa",
        "copiedBody": "Bandika kwenye LinkedIn — kiungo kitafunguka kama kadi ya mradi.",
        "copyFailed": "Imeshindwa kunakili — tafadhali chagua maandishi mwenyewe.",
        "more": "Zaidi",
        "post": "Muundo wa mradi wa majaribio wa kundi la magari ya umeme (mradi wa mteja wa Tanzania, uliobuniwa na MargTor Ltd.):\n\n• Mtaji wa kuanzia $542K\n• Magari 196 — pikipiki 140 za umeme + bajaji 56\n• Makabati 12 ya kubadilisha betri\n• Akiba ya 38.5% kwa siku kwa madereva\n• Faida ya $1.15M katika mwaka wa kwanza kwa ukingo wa faida wa 45.5%\n\nBattery-as-a-Service (BaaS) huweka hatari ya betri kwa mhandisi, si kwa dereva. Hivi ndivyo mradi wa EV unaoweza kufadhiliwa Afrika Mashariki unavyoonekana.",
        "hashtags": "#UsafiriWaUmeme #EMobility #Afrika #BatterySwap #Kenya #Tanzania #MargTor"
      }
    },
    "field": {
      "eyebrow": "Uhalisia wa Mtaani",
      "title": "Huu ndio ulimwengu ambao uhandisi wetu unaujibu.",
      "desc": "Mitaani halisi, kazi halisi. Vumbi, mizigo, umbali — taswira kutoka mahali mifumo yetu itakapofanya kazi kwa kweli.",
      "items": [
        {
          "img": "/assets/img/field-1.jpg",
          "cap": "Boda ya mizigo — barabara kuu ya Nairobi"
        },
        {
          "img": "/assets/img/field-2.jpg",
          "cap": "Kituo cha boda — Bagamoyo, Tanzania"
        },
        {
          "img": "/assets/img/field-3.jpg",
          "cap": "Usafirishaji wa mifugo — vijijini Tanzania"
        },
        {
          "img": "/assets/img/field-4.jpg",
          "cap": "Kituo cha zamu — Nairobi"
        },
        {
          "img": "/assets/img/field-5.jpg",
          "cap": "Safari za mjini — Nairobi"
        }
      ]
    },
    "group": {
      "eyebrow": "Kundi la Arthur Toren",
      "title": "Kundi moja. Biashara nyingi zenye thamani ya juu. Lango moja la Afrika Mashariki.",
      "desc": "MargTor ni kampuni ya uhandisi ya Kundi la Arthur Toren — kundi lenye makao yake Belfast na Nairobi ambalo tangu 2019 limekuwa likileta kampuni za Ulaya nchini Kenya na Tanzania, na kuunganisha usafiri wa umeme, utengenezaji wa betri, programu za kundi la magari, ufadhili wa biashara na ubunifu wa magari. Ikiwa unavutiwa na Afrika Mashariki zaidi ya EV — haya ndiyo mawasiliano sahihi.",
      "holding": "Kundi mama",
      "companiesLabel": "Kampuni na washirika wa kundi",
      "contactEyebrow": "Mawasiliano muhimu kwa wanaovutiwa na Afrika Mashariki",
      "contactTitle": "Kuingia sokoni, usajili wa kampuni, maeneo maalum ya kiuchumi, vibali vya kazi, washirika wa ndani na ufadhili wa upanuzi.",
      "contactDesc": "Timu ya Arthur Toren Associates imesaidia kampuni zaidi ya 20 za EU nchini Kenya na Tanzania. Ushauri wa awali ni bure.",
      "cta": "Tembelea arthurtoren.co.uk",
      "ctaAlt": "Tovuti ya Uingereza",
      "companies": [
        {
          "name": "Arthur Toren Associates",
          "url": "https://arthurtoren.co.uk",
          "role": "Kundi mama · ushauri wa kuingia katika masoko ya Afrika Mashariki (tangu 2019; Belfast · Nairobi)",
          "holding": true
        },
        {
          "name": "MargTor Ltd.",
          "url": "https://margtor.africa",
          "role": "Mshirika wa uhandisi wa EV — makundi ya magari ya 2W/3W, boti, kubadilisha betri na miundombinu ya jua (Nairobi)"
        },
        {
          "name": "electro.technology",
          "url": "https://electro.technology",
          "role": "R&D, udhibiti wa mota na programu za kundi la magari (Poland)"
        },
        {
          "name": "Hadron Energy",
          "url": "https://hadronenergy.pl",
          "role": "Utengenezaji wa betri na hifadhi ya nishati (Poland)"
        },
        {
          "name": "Amperi",
          "url": "https://amperi.eu",
          "role": "Majukwaa ya pikipiki za umeme (Poland)"
        },
        {
          "name": "TOREN PATH",
          "url": "https://path.com.pl",
          "role": "Kundi la biashara la Poland–Afrika · njia za ufadhili, ujumbe wa biashara"
        },
        {
          "name": "Ultre Mobility",
          "url": "https://ultre.city",
          "role": "Studio ya ubunifu wa EV nyepesi"
        },
        {
          "name": "UBBA tech",
          "url": "/knowledge/polish-sez-kenya-ev-manufacturing",
          "role": "Mshirika wa utengenezaji · pikipiki na tuk-tuk za umeme katika SEZ ya Poland na Kenya",
          "internal": true
        }
      ]
    },
    "nav": {
      "knowledge": "Maarifa",
      "solutions": "Suluhisho",
      "manifesto": "Uhandisi",
      "markets": "Masoko",
      "ecosystem": "Mfumo wa Ikolojia",
      "founders": "Waanzilishi",
      "financing": "Ufadhili",
      "economics": "Uchumi",
      "micro": "Nje ya Gridi ya Umeme",
      "contact": "Mawasiliano",
      "cta": "Shirikiana Nasi",
      "ops": "Nairobi • Kinshasa • Dar es Salaam"
    },
    "contact": {
      "eyebrow": "Omba Maelezo ya Kiufundi",
      "title": "Tuipeleke Afrika kwenye umeme — pamoja.",
      "desc": "Tunashirikiana na kampuni za ndani, vyama vya ushirika, wawekezaji, taasisi za elimu na miradi ya serikali kusambaza magari ya umeme, boti za umeme na uchaji wa jua — huku tukipunguza utegemezi wa petroli na dizeli. Maswali hujibiwa ndani ya saa 48.",
      "name": "Jina Kamili",
      "company": "Shirika / Kampuni",
      "email": "Barua Pepe Rasmi",
      "phone": "Simu / WhatsApp",
      "country": "Nchi ya Uendeshaji",
      "solution": "Suluhisho Unalohitaji",
      "fleet": "Ukubwa wa Kundi la magari / Mahitaji ya Nguvu",
      "message": "Maelezo ya Kiufundi",
      "submit": "Tuma Ombi",
      "sending": "Inatuma…",
      "successTitle": "Ombi limepokelewa",
      "successBody": "Timu yetu ya uhandisi itajibu ndani ya saa 48.",
      "errorTitle": "Imeshindwa kutuma",
      "errorBody": "Tafadhali jaribu tena — au tutumie barua pepe moja kwa moja.",
      "countries": [
        "Kenya",
        "DR Kongo",
        "Tanzania",
        "Uganda",
        "Rwanda",
        "Nyingine / Kimataifa"
      ],
      "solutions": [
        "Uhandisi wa EV 2W/3W",
        "Boti za Umeme (Uvuvi na Utalii)",
        "Uchaji na Kubadilisha Betri",
        "ESS / Hifadhi ya Nishati",
        "White Label",
        "Ushirikiano wa Kiufundi / Uwekezaji"
      ],
      "phonesLabel": "Simu za Moja kwa Moja",
      "phones": [
        "+254 719 180 236",
        "+254 708 189 175"
      ],
      "brief": "Pakua Waraka wa Ushirikiano (PDF)",
      "briefFile": "/assets/MargTor-Partnership-Brief.pdf"
    },
    "press": {
      "eyebrow": "Kwenye vyombo vya habari",
      "outlet": "XYZ · xyz.pl",
      "headline": "Mwaka wa kwanza wa eneo maalum la kiuchumi la Poland nchini Kenya. Wapoland wanatengeneza tuk-tuk",
      "desc": "Mwaka 2025 ulikuwa mwaka wa kwanza kamili wa eneo maalum la kiuchumi la Poland nchini Kenya — eneo la pekee nchini lililotengwa kwa wawekezaji wa taifa moja. Kampuni tatu za Poland zipo ndani yake, na nyingine ziko kwenye mazungumzo; UBBA tech inatengeneza pikipiki na tuk-tuk za umeme zenye vidhibiti, BMS na telematiki za Poland kwa ajili ya Tanzania na DRC, huku electro.technology na VGK wakiwa wasambazaji.",
      "facts": [
        {
          "val": "3",
          "label": "kampuni za Poland katika eneo hilo"
        },
        {
          "val": "750+",
          "label": "pikipiki kwa migodi ya DRC (2025)"
        },
        {
          "val": "200+",
          "label": "kwa msambazaji wa Tanzania"
        },
        {
          "val": "1",
          "label": "SEZ pekee ya taifa moja nchini Kenya"
        }
      ],
      "cta": "Uchambuzi wetu katika Knowledge Hub",
      "source": "Soma chanzo xyz.pl",
      "attribution": "Takwimu kwa mujibu wa XYZ (xyz.pl)."
    },
    "knowledge": {
      "loadError": "Imeshindwa kupakia Kituo cha Maarifa kwa sasa.",
      "retry": "Jaribu tena",
      "eyebrow": "Kituo cha Maarifa",
      "title": "Usafiri wa umeme Afrika Mashariki — umeelezwa kutoka uwandani.",
      "desc": "Makala kumi na moja za kiwango cha uhandisi na kamusi kuhusu uchumi wa boda-boda, kubadilisha betri, Battery-as-a-Service, TCO, vituo vya sola, hifadhi, mikopo inayolindwa na telematiki, vyama vya ushirika, ufadhili wa mauzo ya nje na boti za umeme. Wazi kwa watu na mawakala wa AI chini ya CC BY 4.0.",
      "articlesEyebrow": "Makala",
      "articlesTitle": "Mwendeshaji wa kundi la magari, mkopeshaji au mtunga sera anahitaji kujua nini.",
      "glossaryEyebrow": "Kamusi",
      "glossaryTitle": "Maneno ishirini yanayojirudia.",
      "minRead": "dak za kusoma",
      "updated": "Imesasishwa",
      "toolsEyebrow": "Tumia makala hii",
      "cite": "Nakili nukuu",
      "citeCopied": "Nukuu imenakiliwa",
      "citeFailed": "Imeshindwa kunakili nukuu.",
      "openMarkdown": "Toleo la Markdown",
      "openJson": "Toleo la JSON",
      "related": "Soma pia",
      "backToHub": "Kituo cha Maarifa",
      "notFound": "Makala haijapatikana.",
      "ctaTitle": "Unapanga mradi?",
      "ctaDesc": "MargTor hubuni magari, mtandao wa kubadilisha betri na kifurushi cha ufadhili kama mfumo mmoja.",
      "license": {
        "label": "Leseni",
        "attribution": "taja MargTor Ltd., margtor.africa"
      },
      "notes": {
        "eyebrow": "Dondoo za uwandani",
        "title": "Safu ya Gregory Radek — kinachoonekana kutoka Nairobi, si kutoka ukumbi wa mikutano.",
        "desc": "Maandishi mafupi ya mtaalamu mkuu wa pikipiki na bajaji za umeme Afrika Mashariki. Ya binafsi, yenye takwimu na yanayoweza kunukuliwa.",
        "byline": "Gregory Radek · Mwanzilishi Mwenza na CTO · mtaalamu wa EV 2W/3W, Afrika Mashariki",
        "read": "Soma dondoo",
        "back": "Dondoo za uwandani",
        "kind": "Dondoo la uwandani",
        "linkedin": "Fuata LinkedIn"
      },
      "press": {
        "eyebrow": "Kwenye vyombo vya habari",
        "title": "Vyombo vya habari vinasema nini kutuhusu.",
        "read": "Soma chanzo",
        "ours": "Uchambuzi wetu"
      },
      "agents": {
        "eyebrow": "Kwa mawakala wa AI na roboti",
        "title": "Inasomeka na mashine, kwa makusudi.",
        "desc": "Kila ukurasa na makala inapatikana katika Markdown na JSON, pamoja na data ya schema.org, mipasho ya Atom/JSON, seti za data wazi na seva ya MCP yenye kikokotoo cha TCO na utafutaji wa maarifa. Kuorodhesha, kufupisha na kufundisha kunaruhusiwa kwa kutaja chanzo.",
        "links": {
          "llms": "llms.txt",
          "llmsFull": "llms-full.txt (muktadha kamili)",
          "markdown": "Faharasa ya maarifa (Markdown)",
          "mcp": "Seva ya MCP (HTTP inayotiririka)",
          "datasets": "Seti za data wazi (JSON / CSV)",
          "feed": "Mpasho wa Atom",
          "agentCard": "Kadi ya wakala A2A",
          "openapi": "Maelezo ya OpenAPI"
        }
      }
    },
    "footer": {
      "tagline": "Usafiri wa umeme wa kutegemewa, ulioundwa kwa Afrika.",
      "offices": "Nairobi • Kinshasa • Dar es Salaam",
      "legal": "MargTor Ltd. — Imesajiliwa Kenya, ilianzishwa mwaka 2024.",
      "groupPre": "Sehemu ya",
      "groupLink": "kundi la Arthur Toren",
      "groupSite": "arthurtoren.co.uk",
      "groupDesc": "Kundi linalounganisha biashara zenye thamani kubwa Afrika Mashariki — kituo cha kwanza cha mawasiliano kwa wanaovutiwa na kanda hii.",
      "nav": "Faharasa",
      "contact": "Mawasiliano",
      "rights": "Haki zote zimehifadhiwa.",
      "iso": "Usalama na ubora kwa kuzingatia viwango vya ISO",
      "credits": "Picha za mitaani: wachangiaji wa Wikimedia Commons (CC BY-SA) · Maandishi na data:"
    },
    "models": {
      "eyebrow": "Uhandisi ulioidhinishwa kwa vifaa",
      "title": "Mifano ya rejea iliyobuniwa na timu yetu.",
      "desc": "Sampuli za mifumo iliyobuniwa na kuandaliwa kwa uzalishaji na timu ya MargTor pamoja na washirika wake — ushahidi wa kile tunachowasilisha unapotukabidhi kazi.",
      "note": "MargTor ni mshirika wa uhandisi, si duka la magari — mauzo ya B2B na B2C hufanywa na kampuni tofauti ya usambazaji.",
      "items": [
        {
          "code": "TANK",
          "cat": "2W Mjini",
          "img": "/assets/img/models/cut/tank.png",
          "specs": [
            "55 km/h",
            "2.0 kW hub · 3.5 kW peak",
            "72 V · 80 kg"
          ]
        },
        {
          "code": "SUPER TANK",
          "cat": "2W Mjini+",
          "img": "/assets/img/models/cut/super-tank.png",
          "specs": [
            "70 km/h",
            "3.0 kW hub · 5.5 kW peak",
            "72 V · 88 kg"
          ]
        },
        {
          "code": "TIGER",
          "cat": "2W Kasi",
          "img": "/assets/img/models/cut/tiger.png",
          "specs": [
            "120 km/h",
            "7.0 kW hub · 12 kW peak",
            "72 V · 97 kg"
          ]
        },
        {
          "code": "KRAZEE LITE",
          "cat": "2W Boda",
          "img": "/assets/img/models/krazee-lite.png",
          "specs": [
            "75 km/h",
            "3.0 kW mid · 5 kW peak",
            "72 V · 115 kg"
          ]
        },
        {
          "code": "KRAZEE EV50",
          "cat": "2W Boda+",
          "img": "/assets/img/models/cut/krazee-ev50.png",
          "specs": [
            "85 km/h",
            "3.5 kW mid · 6 kW peak",
            "72 V · 125 kg"
          ]
        },
        {
          "code": "KRAZEE EX5",
          "cat": "2W Barabarani",
          "img": "/assets/img/models/cut/krazee-ex5.png",
          "specs": [
            "95 km/h",
            "4.0 kW mid · 7 kW peak",
            "72 V · 125 kg"
          ]
        },
        {
          "code": "THREE-SEATER",
          "cat": "EZEEGO · 3W Abiria",
          "img": "/assets/img/models/cut/three-seater.png",
          "specs": [
            "60 km/h",
            "3 kW PMSM · 9.2 kWh",
            "130–150 km · GVW 750 kg"
          ]
        },
        {
          "code": "SIX-SEATER",
          "cat": "EZEEGO · 3W Abiria XL",
          "img": "/assets/img/models/cut/six-seater.png",
          "specs": [
            "60 km/h",
            "5 kW PMSM · 11.5 kWh",
            "Dhamana ya miaka 5 / km 100k"
          ]
        },
        {
          "code": "CARGO",
          "cat": "EZEEGO · 3W Mizigo",
          "img": "/assets/img/models/cut/cargo.png",
          "specs": [
            "50 km/h",
            "5 kW PMSM",
            "130 km · GVW 1000 kg"
          ]
        }
      ]
    },
    "markets": {
      "eyebrow": "Wigo wa Uendeshaji",
      "title": "Tunafanya kazi pale ambapo uaminifu ni wa lazima.",
      "desc": "Shughuli zinaendelea Afrika Mashariki na ya Kati — zikiwa na mkusanyiko wa ndani, vipuri na msaada wa kihandisi.",
      "items": [
        {
          "country": "Kenya",
          "tag": "Makao Makuu",
          "cities": "Nairobi • Mombasa • Kisumu",
          "focus": "Utekelezaji wa 2W/3W, majaribio ya majini katika Ziwa Victoria, na mitandao ya sola ya kubadilisha betri.",
          "coords": "01°17′S 36°49′E"
        },
        {
          "country": "DR Kongo",
          "tag": "Njia za Mizigo",
          "cities": "Kinshasa • Lubumbashi • Goma",
          "focus": "Usafirishaji mzito wa 3W, msaada kwa migodi, ESS zisizo kwenye gridi na uchaji wa microgrid.",
          "coords": "04°19′S 15°18′E"
        },
        {
          "country": "Tanzania",
          "tag": "Bahari na Kundi la magari",
          "cities": "Dar es Salaam • Arusha",
          "focus": "Ubadilishaji wa boti za umeme kwa wavuvi na usafiri wa maziwa, pamoja na makundi ya magari ya abiria.",
          "coords": "06°47′S 39°12′E"
        }
      ]
    },
    "capital": {
      "eyebrow": "Ushirikiano wa Kundi la Mtaji",
      "title": "Betri hainunuliwi. Ni ya kifamilia.",
      "partnersLabel": "Mfumo wa Ubunifu na Teknolojia",
      "designLine": "Ubunifu wa magari mapya unaendelezwa na Ultre Mobility — studio ya ubunifu wa EV ya ultre.city.",
      "partners": [
        {
          "label": "electro.technology",
          "url": "https://electro.technology",
          "role": "Utafiti na usimamizi wa makundi ya magari"
        },
        {
          "label": "amperi.eu",
          "url": "https://amperi.eu",
          "role": "Mifumo ya Magari"
        },
        {
          "label": "hadronenergy.pl",
          "url": "https://hadronenergy.pl",
          "role": "Utengenezaji wa Betri na ESS"
        },
        {
          "label": "ultre.city",
          "url": "https://ultre.city",
          "role": "Studio ya Ubunifu"
        }
      ],
      "desc": "MargTor inafanya kazi moja kwa moja na watengenezaji wa seli na betri ndani ya kundi lake la mtaji — kuondoa vikwazo vya ugavi, kupunguza gharama kwa kWh, na kuhakikisha kemia salama kwa mazingira ya tropiki.",
      "points": [
        {
          "val": "Moja kwa moja",
          "label": "Mnyororo wa moja kwa moja kutoka seli hadi betri"
        },
        {
          "val": "LFP",
          "label": "Kemia iliyothibitishwa kwa tropiki"
        },
        {
          "val": "100%",
          "label": "Asili ya seli inayofahamika"
        }
      ]
    },
    "marquee": [
      "Magari ya kibiashara ya magurudumu 2 na 3",
      "Injini za majini — za ndani na za nje",
      "Uchaji wa haraka wa AC/DC",
      "Vituo vya kubadilisha betri",
      "Mifumo ya hifadhi ya nishati (ESS)",
      "Ushirikiano na watengenezaji wa betri",
      "Suluhisho za white label",
      "Kenya • DRC • Tanzania"
    ],
    "hero": {
      "eyebrow": "MargTor Ltd. — Ilianzishwa 2024 / Nairobi",
      "l1": "Usafiri wa Umeme",
      "l2": "wa Usahihi, Ulioundwa",
      "l3": "kwa Afrika.",
      "sub": "Ubunifu wa Kenya ukiunganishwa na urithi wa viwanda wa India na Poland. Kampuni huteua MargTor kuwa mshirika wao wa kiufundi wa EV — tunabuni, kusakinisha na kusaidia magari ya 2W & 3W, boti za umeme za uvuvi na utalii, pamoja na miundombinu ya uchargaji wa jua. Tunabadilisha petroli na dizeli kwa nishati ya jua ya Afrika.",
      "cta1": "Chunguza Suluhisho",
      "cta2": "Kuwa Mshirika",
      "coords": "01°17′S 36°49′E — NAIROBI",
      "telemetry": "TELEMATIKI YA MOJA KWA MOJA",
      imgAlt: "Madereva wa boda-boda kwenye barabara yenye vumbi nchini Kenya — mazingira ambayo MargTor huyahandisia",
      "stats": [
        {
          "val": "500+",
          "label": "KG Uwezo wa Kubeba Mizigo"
        },
        {
          "val": "<45s",
          "label": "Muda wa Kubadilisha Betri"
        },
        {
          "val": "03",
          "label": "Masoko Yanayoendelea"
        },
        {
          "val": "50+",
          "label": "Miaka ya Uzoefu"
        }
      ]
    },
    "gwr": {
      "eyebrow": "Uthibitisho Kutoka Barabarani",
      "title": "Rekodi ya Guinness, 2024.",
      "desc": "Safari ya kwanza ya umbali mrefu ya pikipiki ya umeme kuzunguka mipaka yote ya Poland — kwa vifaa vya Amperi vilivyobuniwa ndani ya mfumo wetu. Umbali, uimara wa kuchaji na vifaa vyenyewe vimethibitishwa hadharani, si kwenye karatasi.",
      "chip": "Safari kwa vifaa vya Amperi",
      "caption": "Makao makuu ya Amperi, Poland — timu ya rekodi ya 2024",
      "mototrip": "Awali, Julai 2023, pikipiki zilizobuniwa na Amperi ziliongoza safari kamili ya Electric MotoTrip — Rekodi ya Poland ya kuzunguka ukanda mzima wa mpaka wa nchi, iliyothibitishwa na Biuro Rekordów.",
      "mototripCta": "Biuro Rekordów — Electric MotoTrip",
      "stats": [
        {
          "val": "1",
          "label": "Safari ya Kwanza ya Aina Hii"
        },
        {
          "val": "2024",
          "label": "Rekodi ya Guinness"
        },
        {
          "val": "PL",
          "label": "Mzunguko wa Mipaka"
        }
      ]
    },
    "founders": {
      "eyebrow": "Msingi wa Uhandisi",
      "title": "Imejengwa na wahandisi waliowasilisha bidhaa kwa kiwango kikubwa.",
      "items": [
        {
          "name": "Gurinder Oberoi Singh",
          "photo": "/assets/img/founder-gurinder-studio.jpg",
          "role": "Mwanzilishi Mwenza na Mkurugenzi Mtendaji",
          "heritage": "Mtaalamu wa Magari na EV kutoka India",
          "experience": "Mkurugenzi, VGK Electric • Miaka 30+ katika sekta ya magari • Miaka 15+ katika utengenezaji wa EV",
          "bio": "Yeye ndiye msukumo wa mfululizo wa KRAZEE (pikipiki za umeme) na EZEEGO (magari ya magurudumu matatu). Amehandisi na kuidhinisha bidhaa za EV kwa watengenezaji zaidi ya 480 nchini India, akapata vyeti vya ARAI, na hubuni minyororo ya ugavi hadi kiwango cha kontena. Katika MargTor, anaongoza uanzishaji wa uzalishaji: mkusanyiko mpya, ugavi wa tier-1, mifumo ya ubora na upanuzi barani Afrika.",
          "stats": [
            "Programu 480+ za OEM",
            "ARAI · 2022",
            "CKD 140 / FCL 40ft"
          ],
          "links": []
        },
        {
          "name": "Gregory Radek",
          "photo": "/assets/img/founder-gregory-studio.jpg",
          "role": "Mwanzilishi Mwenza na Afisa Mkuu wa Teknolojia · Mtaalamu mkuu wa EV 2W/3W Afrika Mashariki",
          "badge": "Mtaalamu wa sekta · Pikipiki na bajaji za umeme, Afrika Mashariki",
          "linkedin": "https://www.linkedin.com/in/gregradek/",
          "heritage": "Mhandisi wa Mifumo kutoka Poland",
          "experience": "Mkurugenzi Mtendaji, electro.technology tangu 2019 • Mshauri wa zamani wa CISCO • Miaka 20+ katika IT • Miaka 7+ katika EV",
          "bio": "Anatambulika kama mtaalamu mkuu wa sekta ya pikipiki na bajaji za umeme Afrika Mashariki: amebuni, ameweka na kufadhili makundi ya magari ya e-boda na bajaji za mizigo, mitandao ya kubadilisha betri na telematiki nchini Kenya na Tanzania; anashauri waendeshaji, wakopeshaji na taasisi za umma, na huzungumza katika EVS Kenya na mikutano ya kikanda ya e-mobility. Aliijenga electro.technology kuwa kampuni ya kubuni na kusambaza EV iliyo nyuma ya chapa za Amperi na Newbot — ikiwemo Rekodi ya Dunia ya Guinness ya 2024 ya safari ya pikipiki ya umeme kuzunguka mipaka ya Poland. Kwa miaka sita aliongoza ushauri wa upanuzi wa tamaduni nyingi katika Arthur Toren Associates, na amekuwa akijenga UBBA nchini Kenya tangu 2024. Katika MargTor, anabuni safu iliyounganishwa: udhibiti wa mota, uboreshaji wa betri, telematiki na usimamizi wa kundi la magari.",
          "stats": [
            "Mtaalamu #1 wa EV 2W/3W · Afrika Mashariki",
            "Rekodi ya Dunia ya Guinness · 2024",
            "Mzungumzaji wa EVS Kenya 2025",
            "Chapa za Amperi na Newbot"
          ],
          "links": [
            {
              "label": "LinkedIn",
              "url": "https://www.linkedin.com/in/gregradek/"
            },
            {
              "label": "Amperi",
              "url": "https://amperi.eu"
            },
            {
              "label": "electro.technology",
              "url": "https://electro.technology"
            },
            {
              "label": "Hadron Energy",
              "url": "https://hadronenergy.pl"
            }
          ]
        }
      ]
    },
    "seo": {
      "breadcrumbHome": "Nyumbani",
      "keywords": "MargTor, usafiri wa umeme Afrika, uhandisi wa EV Kenya, boda-boda za umeme, bajaji za umeme, EZEEGO, KRAZEE, kituo cha kubadilisha betri, miundombinu ya kuchaji kwa sola, hifadhi ya nishati ESS, utengenezaji wa white label, mota za umeme za boti, telematiki ya kundi la magari, TCO ya pikipiki ya umeme, BGK, KUKE, Team Poland, mshirika wa kiufundi wa EV, Nairobi, Kinshasa, Dar es Salaam",
      "home": {
        "title": "Uhandisi wa Usafiri wa Umeme kwa Afrika — Makundi ya Magari ya EV, Kubadilisha Betri na Kuchaji kwa Sola",
        "description": "MargTor Ltd. ni mshirika wa kiufundi wa B2B katika usafiri wa umeme nchini Kenya, DRC na Tanzania: uhandisi wa makundi ya magari ya EV ya magurudumu 2 na 3, boti za umeme, kubadilisha betri na kuchaji kwa sola, ESS na utengenezaji wa white label. Urithi wa uhandisi kutoka Kenya, India na Poland.",
        "ogAlt": "MargTor — usafiri wa umeme wa kiwango cha juu, uliobuniwa kwa Afrika. Dereva wa boda-boda nchini Kenya."
      },
      "partners": {
        "title": "Programu ya Washirika — Jinsi Kampuni Zinavyoshirikiana na MargTor",
        "description": "Njia ya hatua 6 kutoka simu ya utangulizi hadi kundi la magari linaloendeshwa: tathmini ya kiufundi, pendekezo la uhandisi, utekelezaji wa majaribio, upanuzi na msaada wa muda mrefu. Kwa waendeshaji wa makundi ya magari, vyama vya ushirika, wawekezaji wa nishati, serikali na wawekezaji.",
        "ogAlt": "Programu ya Washirika ya MargTor — njia kutoka simu ya utangulizi hadi kundi la magari la EV linaloendeshwa.",
        "breadcrumb": "Programu ya Washirika"
      },
      "knowledge": {
        "title": "Kituo cha Maarifa — Usafiri wa Umeme Afrika Mashariki",
        "description": "Makala na kamusi kuhusu uchumi wa boda-boda, kubadilisha betri, Battery-as-a-Service, TCO, vituo vya kubadilisha betri vya sola, hifadhi ya nishati, mikopo inayolindwa na telematiki, vyama vya ushirika, ufadhili wa BGK/KUKE na boti za umeme. CC BY 4.0.",
        "ogAlt": "Kituo cha Maarifa cha MargTor — usafiri wa umeme Afrika Mashariki.",
        "breadcrumb": "Kituo cha Maarifa"
      }
    },
    "micro": {
      "deck": {
        "eyebrow": "Wasilisho la mfano",
        "title": "Powering African Micro-Economies (PDF, slaidi 15)",
        "desc": "Jinsi kituo cha kubadilisha betri kinachotumia nishati ya jua kinavyokuwa huduma ndogo ya nishati ya kijijini: takriban ajira 20 za ndani kwa kila kituo, usafiri wa mazao na mnyororo baridi unaopunguza upotevu, vikundi vya wanawake kama wamiliki, na malipo madogo kupitia pesa za simu. Mfano uliothibitishwa uwandani wa teknolojia ya MargTor unaobadilisha maisha vijijini na katika miji midogo.",
        "cta": "Fungua wasilisho"
      },
      "eyebrow": "Huduma Ndogo za Nishati Nje ya Gridi",
      "title": "Kituo kimoja kinaweza kukipa kijiji umeme — na kuingiza kipato kwa kila chaji.",
      "desc": "Kituo cha kubadilisha betri cha MargTor ni huduma ndogo ya nishati iliyosambazwa: mwavuli wa nishati ya jua, hifadhi na makabati mahiri katika eneo moja. Mfumo huu umethibitishwa katika mradi wa Kenya wenye pikipiki 2,000 za umeme na vituo 70 vinavyohudumia SACCO na vikundi vya wanawake.",
      "proof": [
        "Pikipiki 2,000 katika mradi",
        "Vituo 70 vya kubadilisha betri",
        "SACCO na vikundi vya wanawake, Kenya"
      ],
      "stats": [
        {
          "val": "30 km",
          "label": "Eneo la huduma kwa kituo"
        },
        {
          "val": "~20",
          "label": "Ajira za ndani / Kituo"
        },
        {
          "val": "Wiki 2",
          "label": "Taa za nyumbani / Betri"
        },
        {
          "val": "230 V",
          "label": "Soketi ya kawaida"
        },
        {
          "val": "24",
          "label": "Paki / Siku"
        },
        {
          "val": "100%",
          "label": "Muda wa upatikanaji, jenereta ya dharura"
        }
      ],
      "cards": [
        {
          "title": "Nyumbani",
          "desc": "Betri ileile inayowasha boda-boda pia inaweza kuwasha nyumba: hadi wiki mbili za taa za msingi, feni, friji ndogo na vifaa vya msingi kupitia soketi ya kawaida ya 230 V."
        },
        {
          "title": "Boti za Uvuvi",
          "desc": "Suluhisho kamili kwa maziwa ambako injini za petroli zimepigwa marufuku — uendeshaji safi kwa uvuvi na usafiri wa majini bila kituo cha mafuta."
        },
        {
          "title": "Kituo Huingiza Kipato kwa Kuchaji",
          "desc": "Nishati ya jua ndiyo chanzo cha umeme chenye gharama ya chini zaidi; hata bei za nje ya gridi hubaki chini kuliko petroli. Malipo madogo ya kila siku kupitia pesa za simu hufanya kila ubadilishaji kuwa wa faida — na humfanya mwendeshaji kuwa mtandao wa nishati wa eneo."
        },
        {
          "title": "Uhuru Unapohitajika Zaidi",
          "desc": "Jua kwanza, gridi ikiwa hiari, na jenereta ya dharura inayowaka yenyewe — upatikanaji wa 100% hata katika hali mbaya ya hewa au gridi ikikatika kabisa. Uagizaji wa mafuta ukisimama wakati wa mgogoro wa nishati, vijiji hivi huendelea kufanya kazi."
        }
      ],
      "note": "Hakuna uwekezaji wa gridi ya taifa unaohitajika. Kituo huikwepa kabisa gridi inayochelewa — umeme vijijini mara moja, pamoja na ajira za ndani."
    }
  },
  pl: {
    "marquee": [
      "Komercyjne platformy EV 2W i 3W",
      "Silniki łodziowe — zaburtowe i wbudowane",
      "Szybkie ładowanie AC/DC",
      "Stacje wymiany baterii",
      "Przemysłowe magazyny energii ESS",
      "Sojusz z producentami baterii",
      "Rozwiązania white label",
      "Kenia • DR Konga • Tanzania"
    ],
    "hero": {
      "eyebrow": "MargTor Ltd. — zał. 2024 / siedziba: Nairobi",
      "l1": "Precyzyjna elektromobilność",
      "l2": "projektowana",
      "l3": "dla Afryki.",
      "sub": "Kenijski pomysł połączony z indyjskim i polskim dziedzictwem przemysłowym. Firmy zatrudniają MargTor jako partnera technicznego ds. EV — projektujemy, wdrażamy i obsługujemy floty 2W i 3W, elektryczne łodzie rybackie i turystyczne oraz solarną infrastrukturę ładowania. Benzyna i olej napędowy ustępują afrykańskiemu słońcu.",
      "cta1": "Poznaj kompetencje",
      "cta2": "Zostań partnerem",
      "coords": "01°17′S 36°49′E — NAIROBI",
      "telemetry": "TELEMATYKA FLOTY NA ŻYWO",
      "imgAlt": "Kierowcy boda-boda na zakurzonej kenijskiej ulicy — świat, dla którego projektuje MargTor",
      "stats": [
        {
          "val": "500+",
          "label": "KG ładowności"
        },
        {
          "val": "<45s",
          "label": "Czas wymiany baterii"
        },
        {
          "val": "03",
          "label": "Aktywne rynki"
        },
        {
          "val": "50+",
          "label": "Lat doświadczenia"
        }
      ]
    },
    "markets": {
      "eyebrow": "Zasięg operacyjny",
      "title": "Działamy tam, gdzie niezawodność nie podlega dyskusji.",
      "desc": "Prowadzimy aktywne działania serwisowe w Afryce Wschodniej i Środkowej — z lokalnym montażem, częściami i obecnością inżynierów w terenie.",
      "items": [
        {
          "country": "Kenia",
          "tag": "Siedziba i montaż",
          "cities": "Nairobi • Mombasa • Kisumu",
          "focus": "Wdrożenia flot 2W/3W, testy jednostek pływających na jeziorze Wiktorii, gęste sieci wymiany baterii z PV.",
          "coords": "01°17′S 36°49′E"
        },
        {
          "country": "DR Konga",
          "tag": "Korytarze towarowe",
          "cities": "Kinshasa • Lubumbashi • Goma",
          "focus": "Ciężka logistyka 3W, obsługa transportu dla górnictwa, ESS off-grid i ładowanie z mikrosieci.",
          "coords": "04°19′S 15°18′E"
        },
        {
          "country": "Tanzania",
          "tag": "Żegluga i floty",
          "cities": "Dar es Salaam • Arusha",
          "focus": "Konwersja łodzi na napęd elektryczny dla rybołówstwa i transportu jeziornego oraz podmiejskie floty pasażerskie.",
          "coords": "06°47′S 39°12′E"
        }
      ]
    },
    "gwr": {
      "eyebrow": "Dowód z drogi",
      "title": "Rekord Guinnessa, 2024.",
      "desc": "Pierwszy długodystansowy przejazd elektrycznym motocyklem wzdłuż całej granicy Polski — na sprzęcie Amperi zaprojektowanym w naszym ekosystemie. Zasięg, odporność na ładowanie i wytrzymałość udowodnione publicznie, nie na papierze.",
      "chip": "Przejazd na sprzęcie Amperi",
      "caption": "Siedziba Amperi, Polska — ekipa rekordowego przejazdu 2024",
      "mototrip": "Wcześniej, w lipcu 2023 roku, motocykle zaprojektowane przez Amperi prowadziły przez całą trasę Electric MotoTrip — przejazdu po Rekord Polski wzdłuż całej strefy przygranicznej kraju, poświadczonego przez Biuro Rekordów.",
      "mototripCta": "Biuro Rekordów — Electric MotoTrip",
      "stats": [
        {
          "val": "1.",
          "label": "Taki przejazd na świecie"
        },
        {
          "val": "2024",
          "label": "Rekord Guinnessa"
        },
        {
          "val": "PL",
          "label": "Pętla granic Polski"
        }
      ]
    },
    "micro": {
      "deck": { "eyebrow": "Prezentacja przypadku", "title": "Powering African Micro-Economies (PDF, 15 slajdów)", "desc": "Jak solarny hub wymiany baterii staje się wiejskim mikrozakładem energetycznym: ok. 20 lokalnych miejsc pracy na hub, transport płodów rolnych i chłodnia ograniczające straty plonów, spółdzielnie kobiet jako właścicielki, mikropłatności przez pieniądz mobilny. Sprawdzony w terenie przykład tego, jak technologia MargTor zmienia życie na obszarach wiejskich i w małych miastach.", "cta": "Otwórz prezentację" },
      "eyebrow": "Mikroenergetyka poza siecią",
      "title": "Jeden hub może zelektryfikować wioskę — i zarabiać na każdym ładowaniu.",
      "desc": "Hub wymiany MargTor to zdecentralizowany mikrozakład energetyczny: zadaszenie solarne, magazyn energii i inteligentne szafki w jednym miejscu. Rozwiązanie sprawdzone w kenijskim pilotażu: 2 000 e-motocykli i 70 stacji obsługujących Sacco oraz spółdzielnie kobiet.",
      "proof": [
        "2 000 e-motocykli w pilotażu",
        "70 stacji wymiany",
        "Sacco oraz spółdzielnie kobiet, Kenia"
      ],
      "stats": [
        {
          "val": "30 km",
          "label": "Zasięg hubu"
        },
        {
          "val": "~20",
          "label": "Miejsc pracy / hub"
        },
        {
          "val": "2 tyg.",
          "label": "Zasilanie domu z baterii"
        },
        {
          "val": "230 V",
          "label": "Standardowe gniazdko"
        },
        {
          "val": "24",
          "label": "Pakietów / dzień"
        },
        {
          "val": "100%",
          "label": "Dostępność z generatorem"
        }
      ],
      "cards": [
        {
          "title": "Domy",
          "desc": "Ta sama bateria, która napędza bodę, może zasilać dom: do dwóch tygodni podstawowego oświetlenia, wentylatorów, małych lodówek i niezbędnej elektroniki przez standardowe gniazdko 230 V."
        },
        {
          "title": "Łodzie rybackie",
          "desc": "Uniwersalny pakiet do użytku na jeziorach, gdzie silniki benzynowe są zakazane — czysty napęd dla rybołówstwa i transportu bez przystani paliwowej w zasięgu wzroku."
        },
        {
          "title": "Hub zarabia na ładowaniu",
          "desc": "Energia solarna to najtańszy sposób wejścia; nawet ceny poza siecią pozostają znacznie niższe od kosztu benzyny. Codzienne mikropłatności przez mobile money zamieniają każdą wymianę w marżę — a operatora w lokalną sieć energetyczną."
        },
        {
          "title": "Niezależność, gdy liczy się najbardziej",
          "desc": "Słońce jako główne źródło energii, sieć jako możliwość, automatyczny generator awaryjny — 100% dostępności nawet podczas ekstremalnej pogody lub całkowitej awarii sieci. Gdy w czasie kryzysu energetycznego import paliw staje, te wioski działają dalej."
        }
      ],
      "note": "Bez inwestycji w krajową sieć. Hub całkowicie omija jej ograniczenia — pozwala od razu zelektryfikować wieś i tworzyć lokalne miejsca pracy."
    },
    "founders": {
      "eyebrow": "Rodowód inżynierski",
      "title": "Zbudowana przez inżynierów, którzy wdrażali rozwiązania na dużą skalę.",
      "items": [
        {
          "name": "Gurinder Oberoi Singh",
          "photo": "/assets/img/founder-gurinder-studio.jpg",
          "role": "Współzałożyciel i prezes (CEO)",
          "heritage": "Weteran motoryzacji i elektromobilności z Indii",
          "experience": "Dyrektor, VGK Electric • ponad 30 lat w motoryzacji • ponad 15 lat w produkcji pojazdów elektrycznych",
          "bio": "Przemysłowiec stojący za seriami KRAZEE (e-motocykle) i EZEEGO (trójkołowce). Projektował i homologował pojazdy elektryczne dla ponad 480 producentów w Indiach, uzyskał certyfikację ARAI i projektuje łańcuchy dostaw z dokładnością do kontenera. W MargTor odpowiada za industrializację: uruchamianie montowni od podstaw, zakupy u dostawców tier-1, systemy jakości i ekspansję w Afryce.",
          "stats": [
            "480+ programów OEM",
            "Certyfikacja ARAI · 2022",
            "140 CKD / kontener 40'"
          ],
          "links": []
        },
        {
          "name": "Gregory Radek",
          "photo": "/assets/img/founder-gregory-studio.jpg",
          "role": "Współzałożyciel i CTO · czołowy ekspert EV 2W/3W w Afryce Wschodniej",
          "badge": "Ekspert branżowy · elektryczne jednoślady i trójkołowce, Afryka Wschodnia",
          "linkedin": "https://www.linkedin.com/in/gregradek/",
          "heritage": "Polski inżynier systemów i elektroniki mocy",
          "experience": "CEO electro.technology od 2019 • były konsultant CISCO • ponad 20 lat w IT • ponad 7 lat w EV",
          "bio": "Uznawany za czołowego eksperta branżowego w dziedzinie elektrycznych jednośladów i trójkołowców w Afryce Wschodniej: projektował, wdrażał i finansował floty e-boda i trójkołowców cargo, sieci wymiany baterii oraz telematykę w Kenii i Tanzanii; doradza operatorom, bankom i instytucjom publicznym, występuje na EVS Kenya i regionalnych forach elektromobilności. Zbudował electro.technology — dom projektowo-dystrybucyjny EV stojący za markami Amperi i Newbot — w tym za Rekordem Guinnessa 2024 za przejazd motocyklem elektrycznym wzdłuż granic Polski. Przez sześć lat prowadził wielokulturowe doradztwo ekspansyjne w Arthur Toren Associates, a od 2024 rozwija UBBA w Kenii. W MargTor projektuje warstwę połączoną: sterowanie silnikami, optymalizację baterii, telemetrię i zarządzanie flotą.",
          "stats": [
            "Ekspert nr 1 EV 2W/3W · Afryka Wschodnia",
            "Rekord Guinnessa · 2024",
            "Prelegent EVS Kenya 2025",
            "Marki Amperi i Newbot"
          ],
          "links": [
            {
              "label": "LinkedIn",
              "url": "https://www.linkedin.com/in/gregradek/"
            },
            {
              "label": "Amperi",
              "url": "https://amperi.eu"
            },
            {
              "label": "electro.technology",
              "url": "https://electro.technology"
            },
            {
              "label": "Hadron Energy",
              "url": "https://hadronenergy.pl"
            }
          ]
        }
      ]
    },
    "manifesto": {
      "eyebrow": "Doktryna MargTor",
      "title": "Nie importujemy pojazdów. Projektujemy je tam, gdzie naprawdę będą pracować.",
      "chapters": [
        {
          "num": "01",
          "title": "Zaprojektowane z myślą o lokalnym terenie",
          "desc": "Importowane pojazdy zawodzą na wybojach, stromych podjazdach i przy wysokiej wilgotności. Projektujemy podwozia, układy termiczne i zawieszenie z myślą o rzeczywistych cyklach pracy w Afryce Wschodniej i Środkowej."
        },
        {
          "num": "02",
          "title": "Inżynierskie DNA trzech kontynentów",
          "desc": "Firma założona w 2024 roku, czerpiąca z indyjskiej wielkoseryjnej produkcji motoryzacyjnej i polskiej precyzyjnej elektroniki mocy EV — poprzez ekosystem amperi.eu, electro.technology i Hadron Energy."
        },
        {
          "num": "03",
          "title": "Zdecentralizowana, wymienna energia",
          "desc": "Eliminujemy przestoje związane z ładowaniem u operatorów boda-boda i we flotach rybackich dzięki standardowym modułom baterii i inteligentnym szafom do ich wymiany — energia dotrzymująca tempa pracy."
        },
        {
          "num": "04",
          "title": "White Label dla lokalnych partnerów",
          "desc": "Sprawdzone platformy EV produkowane pod Twoją marką — by lokalne firmy, spółdzielnie i programy publiczne mogły szybko elektryfikować floty, korzystając z naszej inżynierii, telematyki i zaplecza bateryjnego."
        }
      ]
    },
    "seo": {
      "breadcrumbHome": "Strona główna",
      "keywords": "MargTor, elektromobilność w Afryce, inżynieria EV w Kenii, elektryczne boda-boda, elektryczny trójkołowiec, EZEEGO, KRAZEE, stacja wymiany baterii, ładowanie solarne, magazyny energii ESS, white label EV, silniki elektryczne do łodzi, telematyka flot, TCO motocykla elektrycznego, BGK, KUKE, Team Poland, partner techniczny EV, Nairobi, Kinszasa, Dar es Salaam, eksport do Afryki",
      "home": {
        "title": "Inżynieria elektromobilności dla Afryki — floty EV, wymiana baterii i ładowanie solarne",
        "description": "MargTor Ltd. to techniczny partner B2B w dziedzinie elektromobilności w Kenii, DRK i Tanzanii: projektuje floty EV 2W/3W, łodzie elektryczne, systemy wymiany baterii, ładowanie solarne, ESS oraz produkcję white label. Kenijskie, indyjskie i polskie dziedzictwo inżynieryjne.",
        "ogAlt": "MargTor — precyzyjna elektromobilność zaprojektowana dla Afryki. Kierowca boda-boda w Kenii."
      },
      "partners": {
        "title": "Program partnerski — jak firmy współpracują z MargTor",
        "description": "Sześcioetapowa ścieżka współpracy: od rozmowy wstępnej, przez audyt techniczny, propozycję inżynieryjną i pilotaż, po skalowanie i wieloletnie wsparcie. Dla operatorów flot, spółdzielni, deweloperów energetycznych, instytucji publicznych i inwestorów.",
        "ogAlt": "Program partnerski MargTor — ścieżka od rozmowy wstępnej do działającej floty EV.",
        "breadcrumb": "Program partnerski"
      },
      "knowledge": {
        "title": "Baza wiedzy — elektromobilność w Afryce Wschodniej",
        "description": "Artykuły i słownik: ekonomia boda-boda, wymiana baterii, Battery-as-a-Service, TCO, solarne huby wymiany, magazyny energii, kredyt zabezpieczony telematyką, spółdzielnie, finansowanie eksportowe BGK/KUKE i łodzie elektryczne. CC BY 4.0.",
        "ogAlt": "Baza wiedzy MargTor — elektromobilność w Afryce Wschodniej.",
        "breadcrumb": "Baza wiedzy"
      }
    },
    "chat": {
      "launcher": "Zapytaj MargTor",
      "close": "Zamknij",
      "eyebrow": "Asystent bazy wiedzy",
      "title": "Zapytaj MargTor",
      "welcome": "Zapytaj o floty elektryczne, wymianę baterii, TCO, finansowanie lub model partnerski MargTor. Odpowiedzi pochodzą z naszej bazy wiedzy.",
      "suggestions": [
        "Jak działa wymiana baterii dla boda-boda?",
        "Ile dziennie oszczędza elektryczna boda w porównaniu z pojazdem benzynowym?",
        "Jak BGK/KUKE mogą sfinansować sieć wymiany?"
      ],
      "placeholder": "Wpisz pytanie…",
      "send": "Wyślij",
      "typing": "Myślę…",
      "contactCta": "Porozmawiaj z zespołem",
      "error": "Asystent jest chwilowo niedostępny — nasz zespół chętnie odpowie bezpośrednio.",
      "disclaimer": "Odpowiedzi AI na podstawie treści z margtor.africa · bez cen · mogą zawierać błędy"
    },
    "financing": {
      "eyebrow": "Bankowalność od etapu projektu",
      "title": "Każdy program ma dokumentację gotową do finansowania.",
      "desc": "Programy MargTor dostarczamy z gotowymi planami projektów spełniającymi wymogi finansowania oraz dokumentacją do wniosków o finansowanie — kapitał jest elementem planu, a nie blokadą.",
      "cards": [
        {
          "title": "Bankowalne plany projektów",
          "desc": "Studia wykonalności, modele TCO wobec benzyny i diesla, prognozy przepływów pieniężnych i rejestry ryzyka — w standardzie komitetów kredytowych."
        },
        {
          "title": "Ramy Team Poland",
          "desc": "Działamy w ramach Team Poland — wspólnej marki sześciu polskich instytucji rozwoju (PFR, BGK, PAIH, KUKE, PARP, ARP) wspierających ekspansję międzynarodową.",
          "linkLabel": "teampoland.eu",
          "linkUrl": "https://teampoland.eu/"
        },
        {
          "title": "Instytucje finansujące",
          "desc": "Współpracujemy z instytucjami takimi jak BGK — oferującym kredyty rozwojowe i kredyt dla nabywcy — oraz z KUKE (ubezpieczenia kredytów eksportowych) i innymi podmiotami oferującymi instrumenty wsparcia.",
          "linkLabel": "bgk.pl",
          "linkUrl": "https://www.bgk.pl"
        },
        {
          "title": "TOREN PATH",
          "desc": "Nasz partner w zakresie ścieżek finansowania w grupie Arthur Toren: mapowanie instrumentów, strukturyzacja projektów i przygotowanie wniosków od A do Z.",
          "linkLabel": "path.com.pl",
          "linkUrl": "https://path.com.pl"
        },
        {
          "title": "Specjalne strefy ekonomiczne",
          "desc": "Montaż w kenijskich SSE obniża koszty ceł i VAT o ok. 25% — kapitał od razu wraca do zapasów. Pojazdy montowane w Kenii według standardów europejskich można eksportować do UE bez cła w ramach EPA, z etapową ścieżką do certyfikatu „Kenyan Made”."
        }
      ],
      "faqEyebrow": "FAQ finansowania",
      "faq": [
        {
          "q": "Jak ubezpieczenie KUKE pomaga mojemu wdrożeniu?",
          "a": "KUKE ubezpiecza kredyt związany z eksportem polskiego sprzętu. W programie MargTor oznacza to, że ryzyko banku finansującego jest objęte ochroną — m.in. polisą „Polisa bez Granic” — co odblokowuje finansowanie, które inaczej byłoby niedostępne dla wdrożenia w Afryce."
        },
        {
          "q": "Jak działa kredyt dla nabywcy BGK?",
          "a": "W kredycie dla nabywcy BGK finansuje zagranicznego nabywcę polskich dóbr inwestycyjnych. Twoja organizacja otrzymuje długoterminowy kredyt na program, spłacany przez lata — a podstawą kwalifikacji jest polski udział inżynieryjno-sprzętowy w naszej dostawie."
        },
        {
          "q": "Czy KUKE i BGK można łączyć?",
          "a": "Tak — to standardowa struktura: BGK finansuje, KUKE ubezpiecza. TOREN PATH dobiera właściwy zestaw instrumentów dla Twojego projektu i prowadzi wniosek od A do Z."
        },
        {
          "q": "Co MargTor przygotowuje do wniosku?",
          "a": "Bankowalny pakiet dokumentacji: studium wykonalności, model TCO wobec benzyny, prognozę przepływów pieniężnych, rejestr ryzyka i harmonogram — gotowe dla komitetów kredytowych i programów grantowych."
        },
        {
          "q": "Jak kierowcy lub operatorzy flot finansują pojazdy?",
          "a": "Przez bezpośrednie API z lokalnymi bankami (np. KCB, Equity): spłata kredytu jest powiązana z telematyką pojazdu, co zmniejsza ryzyko kredytowe. Testy warunków skrajnych pokazują zwrot modelu wymiany w 8–10 miesięcy, a sieć ładowania staje się samowystarczalna przy ok. 300 aktywnych pojazdach."
        }
      ],
      "eventsEyebrow": "Nadchodzące delegacje",
      "joined": "firm dołączyło", "joinedForms": ["firma dołączyła", "firmy dołączyły", "firm dołączyło"],
      "liveBadge": "Na żywo · path.com.pl",
      "eventsNote": "Wszystkie delegacje organizuje TOREN PATH z pełną asystą — stoiska, logistyka, tłumaczenia i umówione spotkania B2B.",
      "eventsCta": "Dołącz do delegacji",
      "events": [
        {
          "name": "Nairobi International Trade Fair 2026",
          "dates": "29 WRZ – 5 PAŹ 2026",
          "venue": "Jamhuri Park, Nairobi",
          "desc": "Największe targi handlowe Afryki Wschodniej — innowacje i technologia.",
          "url": "https://ask.co.ke/nairobi-international-tradefair/"
        },
        {
          "name": "Uganda–EU Business Forum 2026",
          "dates": "20–21 PAŹ 2026",
          "venue": "Serena Hotel, Kampala",
          "desc": "Projekty OZE gotowe do inwestycji, spotkania B2B i unijne instytucje finansujące.",
          "url": "https://ugeubusinesshub.com/forum-2026/"
        },
        {
          "name": "27th Autoexpo Tanzania 2026",
          "dates": "18–20 LIS 2026",
          "venue": "Diamond Jubilee Expo Centre, Dar es Salaam",
          "desc": "Największe targi motoryzacyjne Afryki Wschodniej — części, akcesoria i wyposażenie.",
          "url": "https://www.expogr.com/tanzania/autoexpo/"
        },
        {
          "name": "28th Autoexpo Kenya 2027",
          "dates": "14–16 LIP 2027",
          "venue": "Carnivore, Nairobi",
          "desc": "Flagowe targi motoryzacyjne Kenii — części, akcesoria i pojazdy użytkowe.",
          "url": "https://www.expogr.com/kenyaauto/"
        }
      ]
    },
    "partners": {
      "eyebrow": "Program partnerski",
      "title": "Jak firmy współpracują z MargTor — krok po kroku.",
      "desc": "Uporządkowany model współpracy — od pierwszej rozmowy po flotę zasilaną słońcem. Ty odpowiadasz za działalność operacyjną, my za inżynierię.",
      "stepsEyebrow": "Ścieżka Współpracy",
      "steps": [
        {
          "num": "01",
          "title": "Rozmowa wstępna",
          "desc": "45-minutowa rozmowa z naszymi inżynierami. Omawiamy Twój cykl pracy: trasy, ładunki, akweny, dostęp do sieci i potencjał PV. Rzetelną ocenę wykonalności otrzymujesz w ciągu 48 godzin."
        },
        {
          "num": "02",
          "title": "Audyt techniczny",
          "desc": "Ocena na miejscu lub zdalna — dane floty, infrastruktura energetyczna, teren i klimat. Efekt: notatka o wykonalności z ryzykami i szansami."
        },
        {
          "num": "03",
          "title": "Propozycja inżynieryjna",
          "desc": "Kompletna specyfikacja programu: dobór platform, topologia ładowania lub wymiany baterii, dobór ESS, telematyka, harmonogram i widełki budżetu. Bez zgadywania."
        },
        {
          "num": "04",
          "title": "Wdrożenie pilotażowe",
          "desc": "Kontrolowany pilotaż — zwykle 5–10 jednostek — z pełną telematyką, szkoleniem kierowców i techników oraz pomiarami na tle obecnej floty."
        },
        {
          "num": "05",
          "title": "Skalowanie",
          "desc": "Pełne wdrożenie z lokalnym montażem lub zestawami CKD tam, gdzie ma to sens, oznakowaniem white-label pod marką partnera i zabezpieczonymi dostawami baterii z grupy kapitałowej."
        },
        {
          "num": "06",
          "title": "Eksploatacja i wsparcie",
          "desc": "Pozostajemy Twoim partnerem technicznym: części, zdalny monitoring floty, szkolenia serwisowe i ciągłe usprawnienia inżynieryjne."
        }
      ],
      "audiencesEyebrow": "Kto Nas Zatrudnia",
      "audiencesTitle": "Stworzone dla organizacji, nie dla salonów.",
      "audiences": [
        {
          "title": "Operatorzy flot i logistyki",
          "desc": "Floty dostawcze, boda-boda i towarowe zastępujące benzynę dobrze zaprojektowanymi programami EV."
        },
        {
          "title": "Spółdzielnie rybackie i turystyczne",
          "desc": "Programy elektryfikacji łodzi na jeziorach i wodach przybrzeżnych."
        },
        {
          "title": "Deweloperzy energetyczni",
          "desc": "Projekty ładowania, wymiany baterii i ESS z integracją mikrosieci PV."
        },
        {
          "title": "Administracja i edukacja",
          "desc": "Floty powiatowe, pracownie zawodowe EV i pilotaże transportu publicznego."
        },
        {
          "title": "Inwestorzy i grupy przemysłowe",
          "desc": "Programy pojazdów white-label i przedsięwzięcia związane z lokalnym montażem."
        }
      ],
      "ctaTitle": "Chcesz zaplanować program?",
      "ctaDesc": "Zacznij od rozmowy wstępnej albo prześlij opis techniczny przez formularz.",
      "cta": "Rozpocznij rozmowę",
      "note": "MargTor jest partnerem inżynieryjnym. Sprzedaż pojazdów prowadzi odrębny podmiot dystrybucyjny.",
      "engEyebrow": "Współpraca Długoterminowa",
      "engTitle": "Zostajemy na lata, nie tylko na czas dostawy.",
      "engDesc": "Każde wdrożenie oznacza co najmniej trzy lata partnerstwa. Prowadzimy Cię przez początkowe etapy, a potem rozwijamy projekt od strony inżynieryjnej.",
      "services": [
        "Prowadzenie programu przez początkowe etapy",
        "Szkolenia kierowców i techników",
        "Nadzór nad zaopatrzeniem — od fabryki w Chinach po plac montażowy",
        "Kwalifikacja i nadzór dostawców",
        "Rozwój nowych produktów na Twój rynek",
        "Doradztwo techniczne w miarę pojawiania się nowych możliwości"
      ],
      "compEyebrow": "Model Wynagrodzenia",
      "compTitle": "Udziały albo stały abonament — zgodnie z Twoim modelem działania.",
      "compDesc": "Przy nowych wdrożeniach preferujemy udziały w przedsięwzięciu, które pomagamy zbudować. W przypadku działających operatorów — długoterminowy abonament techniczny. Tak czy inaczej: wygrywamy, gdy wygrywa Twoja flota."
    },
    "products": {
      "eyebrow": "Matryca kompetencji",
      "title": "Jeden partner techniczny dla całego łańcucha EV.",
      "desc": "Wybierz kompetencję, aby zobaczyć, co projektujemy, integrujemy i wdrażamy.",
      "specLabel": "Specyfikacja wdrożenia",
      "items": [
        {
          "key": "ev",
          "code": "MGT-EV",
          "name": "Inżynieria flot EV 2W i 3W",
          "desc": "Projektujemy wytrzymałe platformy elektrycznych motocykli i trójkołowców towarowo-pasażerskich: wzmocnione podwozia, integrację napędu, homologację i telematykę floty — wdrażane przemysłowo z partnerami produkcyjnymi.",
          "specs": [
            "Do 140 km zasięgu",
            "Ładunek 300–650 kg",
            "Bateria IP67",
            "Hamowanie rekuperacyjne"
          ],
          "img": "/assets/img/boda-karen.jpg"
        },
        {
          "key": "marine",
          "code": "MGT-MR",
          "name": "Silniki do łodzi elektrycznych — zaburtowe i wbudowane",
          "desc": "Bezemisyjny napęd dla łodzi rybackich i turystycznych na jeziorach Wiktorii i Tanganika oraz na szlakach przybrzeżnych. Wysoki moment obrotowy w odpornych na korozję obudowach.",
          "specs": [
            "5–80 kW mocy ciągłej",
            "Chłodzenie cieczą",
            "Cichy tryb eko / patrolowy",
            "Woda słona i słodka"
          ],
          "img": "/assets/img/marine.jpg"
        },
        {
          "key": "charging",
          "code": "MGT-CH",
          "name": "Ładowanie AC/DC i stacje wymiany",
          "desc": "Odporne na wahania parametrów sieci huby szybkiego ładowania DC i zautomatyzowane kioski wymiany baterii z rozliczeniami w chmurze, monitoringiem termicznym i telematyką antykradzieżową.",
          "specs": [
            "Wymiana <45 s",
            "Gotowość do pracy z mikrosieciami PV",
            "12 slotów · 16 kW na szafę",
            "Wyjście AC/DC"
          ],
          "img": "/assets/img/swap-cabinet.jpg"
        },
        {
          "key": "ess",
          "code": "MGT-ES",
          "name": "Przemysłowe magazyny energii ESS",
          "desc": "Magazyny kontenerowe i rack do obiektów komercyjnych, mikrosieci i stacji ładowania off-grid.",
          "specs": [
            "50 kWh – 2 MWh",
            "Chemia LFP, 4000+ cykli",
            "BMS + system przeciwpożarowy",
            "Peak shaving i zasilanie awaryjne"
          ],
          "img": "/assets/img/ess.jpg"
        },
        {
          "key": "iot",
          "code": "MGT-IOT",
          "name": "Telematyka floty i kontrola IoT",
          "desc": "Każda platforma ma urządzenie IoT wbudowane w sterownik silnika — ingerencja całkowicie unieruchamia pojazd. Diagnostyka CAN na żywo, zdalne wyłączenie, blokada antykradzieżowa, geo-fencing i lokalny limit prędkości.",
          "specs": [
            "IoT w sterowniku FarDriver",
            "Diagnostyka CAN na żywo",
            "Zdalne wyłączenie i geo-fencing",
            "Łączność awaryjna 4G → 2G → SMS → LoRa",
            "API fintech — KCB, Equity"
          ],
          "img": "/assets/img/engineering.jpg"
        },
        {
          "key": "white",
          "code": "MGT-WL",
          "name": "Produkcja white label",
          "desc": "Sprawdzone platformy 2W/3W, napędy do łodzi i infrastruktura wymiany produkowane pod Twoją marką — zestawy CKD/SKD, telematyka floty i szkolenia wdrożeniowe dla partnerów.",
          "specs": [
            "Sprawdzone projekty platform",
            "Twoja marka, nasza inżynieria",
            "API telemetrii przeznaczone dla Twojej marki",
            "Szkolenia montażowe"
          ],
          "img": "/assets/img/assembly-line.png"
        }
      ]
    },
    "pilot": {
      "eyebrow": "Anatomia pilotażu",
      "title": "Projekt klienta z Tanzanii — rzeczywisty plan wdrożenia.",
      "stats": [
        {
          "val": "$542K",
          "label": "CapEx pilotażu"
        },
        {
          "val": "196",
          "label": "Pojazdy · 140 2W + 56 3W"
        },
        {
          "val": "12",
          "label": "Szafy wymiany"
        },
        {
          "val": "38.5%",
          "label": "Dzienne oszczędności"
        },
        {
          "val": "$1.15M",
          "label": "Zysk netto w 1. roku"
        },
        {
          "val": "45.5%",
          "label": "Marża netto"
        }
      ],
      "note": "Pojazdy bez baterii sprzedawane po cenie porównywalnej z pojazdami spalinowymi; bateria pozostaje nasza jako usługa (BaaS) — kierowcy obniżają dzienne koszty energii i serwisu o 38,5%. Łańcuch dostaw: Chiny → Afryka Wschodnia w 45–55 dni. Model na 3. rok: ok. 23 000 aktywnych motocykli.",
      "cta": "Zobacz model współpracy",
      "download": "Pobierz strategię pilotażu (PDF)",
      "share": {
        "eyebrow": "Podziel się tymi liczbami",
        "desc": "Jedno kliknięcie publikuje kartę pilotażu z kluczowymi danymi w Twojej sieci — podgląd linku wyświetli dokładnie tę kartę. Skopiuj gotowy tekst posta i dodaj własny komentarz.",
        "previewTag": "Podgląd linku",
        "cardTitle": "Anatomia pilotażu — MargTor Ltd.",
        "cardAlt": "Karta ekonomiki pilotażu MargTor: CapEx $542K, 196 pojazdów, 12 szaf wymiany, 38,5% dziennych oszczędności kierowców, $1,15M zysku netto w 1. roku, marża 45,5%.",
        "linkedin": "Udostępnij na LinkedIn",
        "copy": "Kopiuj tekst posta",
        "copied": "Skopiowano",
        "copiedTitle": "Post skopiowany",
        "copiedBody": "Wklej na LinkedIn — link rozwinie się w kartę pilotażu.",
        "copyFailed": "Nie udało się skopiować — zaznacz tekst ręcznie.",
        "more": "Więcej",
        "post": "Anatomia pilotażu floty elektrycznej (projekt klienta z Tanzanii, inżynieria MargTor Ltd.):\n\n• $542K CapEx pilotażu\n• 196 pojazdów — 140 e-motocykli + 56 trójkołowców\n• 12 szaf wymiany baterii\n• 38,5% dziennych oszczędności dla kierowców\n• $1,15M zysku netto w 1. roku przy marży 45,5%\n\nBattery-as-a-Service pozostawia ryzyko związane z baterią po stronie inżyniera, a nie kierowcy. Tak wygląda wdrożenie EV w Afryce Wschodniej, które można finansować — z finansowaniem BGK/KUKE w zasięgu.",
        "hashtags": "#Elektromobilność #EMobility #Afryka #BatterySwap #Kenia #Tanzania #TeamPoland #MargTor"
      }
    },
    "field": {
      "eyebrow": "Rzeczywistość ulicy",
      "title": "To świat, na który odpowiada nasza inżynieria.",
      "desc": "Prawdziwe ulice, prawdziwe cykle pracy. Kurz, ładunek, dystans — sfotografowane tam, gdzie nasze platformy będą rzeczywiście pracować.",
      "items": [
        {
          "img": "/assets/img/field-1.jpg",
          "cap": "Boda towarowa — obwodnica Nairobi"
        },
        {
          "img": "/assets/img/field-2.jpg",
          "cap": "Postój boda — Bagamoyo, Tanzania"
        },
        {
          "img": "/assets/img/field-3.jpg",
          "cap": "Transport zwierząt — wiejska Tanzania"
        },
        {
          "img": "/assets/img/field-4.jpg",
          "cap": "Postój w godzinach szczytu — Nairobi"
        },
        {
          "img": "/assets/img/field-5.jpg",
          "cap": "Dojazdy miejskie — Nairobi"
        }
      ]
    },
    "booking": {
      "eyebrow": "Rozmowa wstępna",
      "title": "Zarezerwuj 45-minutową rozmowę wstępną.",
      "desc": "Wybierz termin, opisz swoją flotę, obszar działania lub lokalizację, a my wyślemy e-mail z potwierdzeniem i zaproszeniem do kalendarza. Ocenę wykonalności przygotujemy w ciągu 48 godzin od rozmowy.",
      "tz": "Czas Nairobi (EAT, UTC+3) · pn–pt 10:00–16:00",
      "step1": "1 · Wybierz dzień",
      "step2": "2 · Wybierz godzinę",
      "step3": "3 · Twoje dane",
      "name": "Imię i nazwisko",
      "email": "Służbowy e-mail",
      "company": "Firma / spółdzielnia",
      "phone": "Telefon (opcjonalnie)",
      "topic": "O czym chcesz porozmawiać?",
      "selected": "Wybrano",
      "pickSlot": "Najpierw wybierz dzień i godzinę",
      "submit": "Potwierdź rezerwację",
      "sending": "Rezerwuję…",
      "taken": "Ten termin właśnie został zajęty — wybierz inny.",
      "error": "Nie udało się dokończyć rezerwacji. Spróbuj ponownie lub skorzystaj z formularza kontaktowego.",
      "successToast": "Rozmowa wstępna zarezerwowana",
      "confirmed": "Zarezerwowano",
      "emailSent": "Potwierdzenie z zaproszeniem do kalendarza wysłano na Twój e-mail.",
      "emailPending": "Rezerwacja została zapisana; dodaj ją do kalendarza poniżej.",
      "ics": "Pobierz .ics",
      "gcal": "Dodaj do Google Calendar",
      "meet": "Dołącz przez Google Meet",
      "meetReady": "Link do Google Meet jest w zaproszeniu.",
      "syncedBadge": "Automatyczne zaproszenie do Google Meet"
    },
    "tco": {
      "eyebrow": "Ekonomia floty",
      "title": "Liczby, które komitet kredytowy może zweryfikować.",
      "desc": "Modele możliwe do zweryfikowania — każde założenie jawne, arytmetyka otwarta, dane wejściowe możesz zmienić samodzielnie.",
      "integrationEyebrow": "Integracja flot boda-boda",
      "metrics": [
        {
          "val": "650 kg",
          "label": "Maks. ładunek (3W)"
        },
        {
          "val": "30°",
          "label": "Wzniesienia z ładunkiem"
        },
        {
          "val": "<45 s",
          "label": "Wymiana baterii"
        },
        {
          "val": "18–20 h",
          "label": "Dzienna dostępność"
        },
        {
          "val": "130–150 km",
          "label": "Zasięg 3W / ładowanie"
        },
        {
          "val": "5 lat",
          "label": "Gwarancja · 100 tys. km"
        }
      ],
      "integrationNote": "Każdy pojazd ma moduł IoT wbudowany w sterownik FarDriver — diagnostykę CAN na żywo, geo-fencing, zdalne wyłączenie — oraz API floty zgodne z używanym już oprogramowaniem do zarządzania i systemami fintech (KCB, Equity).",
      "tableEyebrow": "TCO — na motocykl, 5-letni cykl boda",
      "assumption": "Założenia: ~150 km/dzień, 360 dni roboczych/rok, benzyna ≈ 180 KES/l, wymiana ≈ 30 KES/pakiet, sam pojazd w parytecie cenowym z ICE, bateria jako usługa.",
      "colA": "Motocykl spalinowy",
      "colB": "Elektryczny MargTor",
      "rows": [
        [
          "Koszt energii / dzień",
          "≈ 260 KES paliwo",
          "≈ 60 KES (2 wymiany)"
        ],
        [
          "Koszt operacyjny / dzień",
          "≈ 10,03 USD",
          "≈ 6,17 USD"
        ],
        [
          "Profil serwisowy",
          "Silnik, olej, łańcuch, sprzęgło",
          "Silnik w piaście lub centralny — minimum części"
        ],
        [
          "Dzienne oszczędności kierowcy",
          "—",
          "38,5%"
        ],
        [
          "Delta 5-letnia",
          "Baza",
          "≈ 6 900 USD / motocykl"
        ],
        [
          "Ryzyko baterii",
          "—",
          "Po stronie MargTor — BaaS"
        ],
        [
          "Przestoje",
          "Kolejki po paliwo, warsztat",
          "Wymiana <45 s, szafy 24/7"
        ]
      ],
      "footnote": "Telematyka z działającego wdrożenia · FX ≈ 129 KES/USD · pełny model w procesie partnerskim",
      "calc": {
        "eyebrow": "Kalkulator TCO na żywo",
        "desc": "Przeciągnij suwaki — oszczędności przeliczają się natychmiast. To ten sam model co w tabeli powyżej.",
        "kmLabel": "Dystans na motocykl / dzień",
        "fuelLabel": "Cena benzyny",
        "fleetLabel": "Wielkość floty",
        "fleetUnit": "motocykli",
        "outDaily": "Oszczędność / motocykl / dzień",
        "outPct": "Oszczędność kierowcy",
        "outMonth": "Oszczędność floty / miesiąc",
        "out5y": "Oszczędność floty / 5 lat",
        "constants": "Stałe: 45 km/l · 30 KES za wymianę (≈75 km) · BaaS 425 KES/motocykl/dzień · serwis EV ≈ 45% ICE"
      },
      "share": {
        "eyebrow": "Udostępnij swój wynik",
        "desc": "Karta z Twoimi liczbami — podgląd linku na LinkedIn i WhatsApp pokazuje dokładnie te wartości. Przesuń suwaki, a karta zaktualizuje się sama.",
        "previewTag": "Podgląd linku",
        "linkedin": "Udostępnij na LinkedIn",
        "copy": "Kopiuj tekst posta",
        "copied": "Skopiowano",
        "copiedTitle": "Post skopiowany",
        "copiedBody": "Wklej na LinkedIn — link rozwinie się w Twoją kartę oszczędności.",
        "copyFailed": "Nie udało się skopiować — zaznacz tekst ręcznie.",
        "download": "Pobierz PNG",
        "alt": "Karta oszczędności TCO MargTor z moimi założeniami",
        "post": "Policzyłem to dla floty {fleet} elektrycznych motocykli w Kenii ({km} km/dzień, benzyna {fuel} KES/l):\n\n• {daily} KES oszczędności na motocykl dziennie\n• o {pct}% niższe koszty dla kierowcy\n• {month} KES miesięcznie dla floty\n• {five} w 5 lat\n\nModel: Battery-as-a-Service, 45 km/l, serwis EV ≈ 45% ICE. Kalkulator TCO MargTor Ltd.:",
        "hashtags": "#Elektromobilność #EMobility #Afryka #Kenia #BatterySwap #FleetElectrification #TCO #MargTor"
      },
      "uwEyebrow": "Underwriting i finansowanie",
      "uwCards": [
        {
          "title": "Kredyt zabezpieczony telematyką",
          "desc": "Spłata powiązana z pojazdem: zdalne wyłączenie i geo-fencing działają jako zabezpieczenie cyfrowe. Skuteczność windykacji na poziomie 90% potwierdzono na dużą skalę właśnie dzięki temu mechanizmowi."
        },
        {
          "title": "Struktury mikrofinansowania",
          "desc": "Dzienne i tygodniowe mikropłatności dopasowane do przepływów kierowcy, przez mobile money i API bankowe — ocena ryzyka kredytowego oparta na telemetrycznych danych o zarobkach, nie na dokumentach."
        },
        {
          "title": "Leasing z wykupem dla flot",
          "desc": "Floty leasują same pojazdy, a bateria pozostaje usługą: ryzyko baterii zostaje po stronie MargTor, pojazd amortyzuje się przez 3–5 lat, a własność przechodzi na flotę po zakończeniu okresu leasingu."
        },
        {
          "title": "Warstwa kapitału instytucjonalnego",
          "desc": "CapEx programu strukturyzujemy kredytem dla nabywcy BGK, ubezpieczeniem KUKE i instrumentami Team Poland (patrz Finansowanie). Finansowanie pojazdów pozostaje lokalne."
        }
      ]
    },
    "contact": {
      "eyebrow": "Zapytanie ofertowe",
      "title": "Wdrażajmy elektromobilność — razem.",
      "desc": "Współpracujemy z lokalnymi firmami, spółdzielniami, inwestorami, instytucjami edukacyjnymi i administracją przy wdrażaniu flot EV, łodzi elektrycznych i ładowania solarnego — by uniezależniać się od benzyny i oleju napędowego. Odpowiadamy w ciągu 48 godzin.",
      "name": "Imię i nazwisko",
      "company": "Organizacja / firma",
      "email": "Służbowy adres e-mail",
      "phone": "Telefon / WhatsApp",
      "country": "Kraj działalności",
      "solution": "Interesujące Cię rozwiązanie",
      "fleet": "Wielkość floty / zapotrzebowanie na moc",
      "message": "Opis techniczny i wymagania",
      "submit": "Wyślij zapytanie",
      "sending": "Wysyłanie…",
      "successTitle": "Zapytanie zostało przyjęte",
      "successBody": "Nasz zespół inżynieryjny odpowie w ciągu 48 godzin.",
      "errorTitle": "Nie udało się wysłać wiadomości",
      "errorBody": "Spróbuj ponownie — lub napisz do nas bezpośrednio.",
      "countries": [
        "Kenia",
        "DRK",
        "Tanzania",
        "Uganda",
        "Rwanda",
        "Inny kraj / międzynarodowo"
      ],
      "solutions": [
        "Inżynieria flot EV 2W/3W",
        "Łodzie elektryczne (rybołówstwo i turystyka)",
        "Infrastruktura ładowania i wymiany baterii",
        "ESS / magazyny energii",
        "Produkcja white label",
        "Partnerstwo techniczne / inwestycje"
      ],
      "phonesLabel": "Numery bezpośrednie",
      "phones": [
        "+254 719 180 236",
        "+254 708 189 175"
      ],
      "brief": "Pobierz broszurę partnerską (PDF, PL)",
      "briefFile": "/assets/MargTor-Partnership-Brief-PL.pdf"
    },
    "group": {
      "eyebrow": "Grupa Arthur Toren",
      "title": "Jeden holding. Wiele wartościowych spółek. Jedna brama do Afryki Wschodniej.",
      "desc": "MargTor jest spółką inżynieryjną grupy Arthur Toren — holdingu z Belfastu i Nairobi, który od 2019 roku wprowadza europejskie firmy do Kenii i Tanzanii oraz łączy elektromobilność, produkcję baterii, oprogramowanie flotowe, finansowanie handlu i wzornictwo pojazdów. Jeśli interesuje Cię Afryka Wschodnia nie tylko w obszarze EV — to właściwy kontakt.",
      "holding": "Holding",
      "companiesLabel": "Spółki i partnerzy grupy",
      "contactEyebrow": "Wartościowy kontakt dla zainteresowanych Afryką Wschodnią",
      "contactTitle": "Wejście na rynek, rejestracja spółki, strefy ekonomiczne, pozwolenia na pracę, partnerzy lokalni, finansowanie ekspansji.",
      "contactDesc": "Zespół Arthur Toren Associates pomógł już ponad 20 firmom z UE wejść na rynek w Kenii i Tanzanii. Pierwsza konsultacja jest bezpłatna.",
      "cta": "Odwiedź arthurtoren.co.uk",
      "ctaAlt": "Strona UK",
      "companies": [
        {
          "name": "Arthur Toren Associates",
          "url": "https://arthurtoren.co.uk",
          "role": "Holding · doradztwo przy wejściu na rynki Afryki Wschodniej (od 2019; Belfast · Nairobi)",
          "holding": true
        },
        {
          "name": "MargTor Ltd.",
          "url": "https://margtor.africa",
          "role": "Partner inżynieryjny EV — floty 2W/3W, łodzie, wymiana baterii i infrastruktura solarna (Nairobi)"
        },
        {
          "name": "electro.technology",
          "url": "https://electro.technology",
          "role": "B+R, sterowanie silnikami i oprogramowanie flotowe (Polska)"
        },
        {
          "name": "Hadron Energy",
          "url": "https://hadronenergy.pl",
          "role": "Produkcja baterii i magazynów energii (Polska)"
        },
        {
          "name": "Amperi",
          "url": "https://amperi.eu",
          "role": "Platformy motocykli elektrycznych (Polska)"
        },
        {
          "name": "TOREN PATH",
          "url": "https://path.com.pl",
          "role": "Polsko-afrykański holding handlowy · ścieżki finansowania, delegacje"
        },
        {
          "name": "Ultre Mobility",
          "url": "https://ultre.city",
          "role": "Studio wzornictwa ultralekkich EV"
        },
        {
          "name": "UBBA tech",
          "url": "/knowledge/polish-sez-kenya-ev-manufacturing",
          "role": "Partner produkcyjny · e-motocykle i tuk-tuki w polskiej SSE w Kenii",
          "internal": true
        }
      ]
    },
    "footer": {
      "tagline": "Precyzyjna elektromobilność projektowana dla Afryki.",
      "offices": "Nairobi • Kinszasa • Dar es Salaam",
      "legal": "MargTor Ltd. — spółka zarejestrowana w Kenii, założona w 2024 roku.",
      "groupPre": "Część",
      "groupLink": "grupy Arthur Toren",
      "groupSite": "arthurtoren.co.uk",
      "groupDesc": "Holding skupiający firmy o dużej wartości w Afryce Wschodniej — pierwszy punkt kontaktu dla podmiotów zainteresowanych regionem.",
      "nav": "Indeks",
      "contact": "Kontakt",
      "rights": "Wszelkie prawa zastrzeżone.",
      "iso": "Bezpieczeństwo i jakość zgodne z normami ISO",
      "credits": "Fotografie uliczne: autorzy Wikimedia Commons (CC BY-SA) · Tekst i dane:"
    },
    "press": {
      "eyebrow": "W mediach",
      "outlet": "XYZ · xyz.pl",
      "headline": "Pierwszy rok polskiej strefy ekonomicznej w Kenii. Polacy produkują tuk-tuki",
      "desc": "Rok 2025 był pierwszym pełnym rokiem działalności polskiej specjalnej strefy ekonomicznej w Kenii — jedynej w kraju przeznaczonej dla inwestorów z jednego państwa. Działają w niej trzy polskie firmy, a z kolejnymi trwają rozmowy; UBBA tech produkuje e-motocykle i tuk-tuki z polskimi sterownikami, systemami BMS i rozwiązaniami IoT na eksport do Tanzanii i DRK, a wśród dostawców są electro.technology i VGK.",
      "facts": [
        {
          "val": "3",
          "label": "polskie firmy w strefie"
        },
        {
          "val": "750+",
          "label": "motocykli dla kopalni w DRK (2025)"
        },
        {
          "val": "200+",
          "label": "dla dystrybutora w Tanzanii"
        },
        {
          "val": "1",
          "label": "jedyna „krajowa” SSE w Kenii"
        }
      ],
      "cta": "Nasze omówienie w Bazie wiedzy",
      "source": "Czytaj źródło na xyz.pl",
      "attribution": "Dane za XYZ (xyz.pl)."
    },
    "nav": {
      "knowledge": "Wiedza",
      "solutions": "Kompetencje",
      "manifesto": "Inżynieria",
      "markets": "Rynki",
      "ecosystem": "Ekosystem",
      "founders": "Założyciele",
      "financing": "Finansowanie",
      "economics": "Ekonomia",
      "micro": "Poza siecią",
      "contact": "Kontakt",
      "cta": "Zostań partnerem",
      "ops": "Nairobi • Kinszasa • Dar es Salaam"
    },
    "models": {
      "eyebrow": "Inżynieria potwierdzona w praktyce",
      "title": "Platformy referencyjne zaprojektowane przez nasz zespół.",
      "desc": "Przykłady platform zaprojektowanych, homologowanych i wdrożonych do produkcji przez zespół MargTor we współpracy z partnerami — dowód tego, co dostarczamy, gdy nas zatrudniasz.",
      "note": "MargTor jest partnerem inżynieryjnym, a nie sklepem z pojazdami — sprzedaż B2B i B2C prowadzi osobny podmiot dystrybucyjny.",
      "items": [
        {
          "code": "TANK",
          "cat": "2W Miejski",
          "img": "/assets/img/models/cut/tank.png",
          "specs": [
            "55 km/h",
            "2,0 kW w piaście · 3,5 kW szczytowo",
            "72 V · 80 kg"
          ]
        },
        {
          "code": "SUPER TANK",
          "cat": "2W Miejski+",
          "img": "/assets/img/models/cut/super-tank.png",
          "specs": [
            "70 km/h",
            "3,0 kW w piaście · 5,5 kW szczytowo",
            "72 V · 88 kg"
          ]
        },
        {
          "code": "TIGER",
          "cat": "2W wyczynowy",
          "img": "/assets/img/models/cut/tiger.png",
          "specs": [
            "120 km/h",
            "7,0 kW w piaście · 12 kW szczytowo",
            "72 V · 97 kg"
          ]
        },
        {
          "code": "KRAZEE LITE",
          "cat": "2W Boda",
          "img": "/assets/img/models/krazee-lite.png",
          "specs": [
            "75 km/h",
            "3,0 kW centralny · 5 kW szczytowo",
            "72 V · 115 kg"
          ]
        },
        {
          "code": "KRAZEE EV50",
          "cat": "2W Boda+",
          "img": "/assets/img/models/cut/krazee-ev50.png",
          "specs": [
            "85 km/h",
            "3,5 kW centralny · 6 kW szczytowo",
            "72 V · 125 kg"
          ]
        },
        {
          "code": "KRAZEE EX5",
          "cat": "2W Uliczny",
          "img": "/assets/img/models/cut/krazee-ex5.png",
          "specs": [
            "95 km/h",
            "4,0 kW centralny · 7 kW szczytowo",
            "72 V · 125 kg"
          ]
        },
        {
          "code": "THREE-SEATER",
          "cat": "EZEEGO · 3W Pasażerski",
          "img": "/assets/img/models/cut/three-seater.png",
          "specs": [
            "60 km/h",
            "3 kW PMSM · 9,2 kWh",
            "130–150 km · GVW 750 kg"
          ]
        },
        {
          "code": "SIX-SEATER",
          "cat": "EZEEGO · 3W Pasażerski XL",
          "img": "/assets/img/models/cut/six-seater.png",
          "specs": [
            "60 km/h",
            "5 kW PMSM · 11,5 kWh",
            "Gwarancja 5 lat / 100 tys. km"
          ]
        },
        {
          "code": "CARGO",
          "cat": "EZEEGO · 3W Cargo",
          "img": "/assets/img/models/cut/cargo.png",
          "specs": [
            "50 km/h",
            "5 kW PMSM",
            "130 km · GVW 1000 kg"
          ]
        }
      ]
    },
    "knowledge": {
      "loadError": "Nie udało się teraz wczytać bazy wiedzy.",
      "retry": "Spróbuj ponownie",
      "eyebrow": "Baza wiedzy",
      "title": "Elektromobilność w Afryce Wschodniej — wyjaśniona z perspektywy terenu.",
      "desc": "Jedenaście artykułów na poziomie inżynierskim i słownik: ekonomia boda-boda, wymiana baterii, Battery-as-a-Service, TCO, huby solarne, magazyny energii, kredyt zabezpieczony telematyką, spółdzielnie, finansowanie eksportowe i łodzie elektryczne. Otwarte dla ludzi i agentów AI na licencji CC BY 4.0.",
      "articlesEyebrow": "Artykuły",
      "articlesTitle": "Co powinien wiedzieć operator floty, bank lub decydent.",
      "glossaryEyebrow": "Słownik",
      "glossaryTitle": "Dwadzieścia pojęć, które stale wracają.",
      "minRead": "min czytania",
      "updated": "Aktualizacja",
      "toolsEyebrow": "Wykorzystaj ten artykuł",
      "cite": "Kopiuj cytowanie",
      "citeCopied": "Cytowanie skopiowano",
      "citeFailed": "Nie udało się skopiować cytowania.",
      "openMarkdown": "Wersja Markdown",
      "openJson": "Wersja JSON",
      "related": "Czytaj dalej",
      "backToHub": "Baza wiedzy",
      "notFound": "Nie znaleziono artykułu.",
      "ctaTitle": "Planujesz wdrożenie?",
      "ctaDesc": "MargTor projektuje pojazdy, sieć wymiany i pakiet finansowy jako jeden system.",
      "license": {
        "label": "Licencja",
        "attribution": "podaj źródło: MargTor Ltd., margtor.africa"
      },
      "notes": {
        "eyebrow": "Notatki z terenu",
        "title": "Kolumna Gregory’ego Radka — co widać z Nairobi, a nie z sali konferencyjnej.",
        "desc": "Krótkie wpisy czołowego eksperta od elektrycznych jednośladów i trójkołowców w Afryce Wschodniej. Osobiste, oparte na liczbach, cytowalne.",
        "byline": "Gregory Radek · współzałożyciel i CTO · ekspert EV 2W/3W, Afryka Wschodnia",
        "read": "Czytaj notatkę",
        "back": "Notatki z terenu",
        "kind": "Notatka z terenu",
        "linkedin": "Obserwuj na LinkedIn"
      },
      "press": {
        "eyebrow": "W mediach",
        "title": "Co media piszą o nas.",
        "read": "Czytaj źródło",
        "ours": "Nasze omówienie"
      },
      "agents": {
        "eyebrow": "Dla agentów AI i robotów",
        "title": "Czytelne maszynowo — od początku.",
        "desc": "Każda strona i każdy artykuł są dostępne w formacie Markdown i JSON, z danymi schema.org, kanałami Atom/JSON, otwartymi zbiorami danych i serwerem MCP, który udostępnia kalkulator TCO oraz wyszukiwarkę wiedzy. Indeksowanie, streszczanie i trenowanie są dozwolone pod warunkiem podania źródła.",
        "links": {
          "llms": "llms.txt",
          "llmsFull": "llms-full.txt (pełny kontekst)",
          "markdown": "Indeks wiedzy (Markdown)",
          "mcp": "Serwer MCP (streamable HTTP)",
          "datasets": "Otwarte zbiory danych (JSON / CSV)",
          "feed": "Kanał Atom",
          "agentCard": "Karta agenta A2A",
          "openapi": "Specyfikacja OpenAPI"
        }
      }
    },
    "capital": {
      "eyebrow": "Synergia grupy kapitałowej",
      "title": "Baterii nie kupujemy. Produkujemy je w rodzinie.",
      "partnersLabel": "Ekosystem wzornictwa i rozwiązań technicznych",
      "designLine": "Projekt nowych pojazdów powstaje z Ultre Mobility — studiem wzornictwa ultralekkich EV ultre.city.",
      "partners": [
        {
          "label": "electro.technology",
          "url": "https://electro.technology",
          "role": "R&D i kontrola floty"
        },
        {
          "label": "amperi.eu",
          "url": "https://amperi.eu",
          "role": "Platformy pojazdów"
        },
        {
          "label": "hadronenergy.pl",
          "url": "https://hadronenergy.pl",
          "role": "Produkcja baterii i ESS"
        },
        {
          "label": "ultre.city",
          "url": "https://ultre.city",
          "role": "Studio wzornictwa"
        }
      ],
      "desc": "MargTor współpracuje bezpośrednio z producentami ogniw i pakietów baterii w ramach własnej grupy kapitałowej — eliminuje wąskie gardła, obniża koszt kWh i zapewnia chemię testowaną w klimacie tropikalnym.",
      "points": [
        {
          "val": "Bezpośrednia",
          "label": "Linia dostaw: ogniwo–pakiet"
        },
        {
          "val": "LFP",
          "label": "Chemia testowana w tropikach"
        },
        {
          "val": "100%",
          "label": "Identyfikowalne pochodzenie ogniw"
        }
      ]
    }
  },
};

// ---merge---
translations.fr = generated.fr;
translations.zh = generated.zh;
Object.assign(translations.sw, { china: generated.sw.china, amperi: generated.sw.amperi });
Object.assign(translations.sw.group, generated.sw.group);
Object.assign(translations.pl, { china: generated.pl.china, amperi: generated.pl.amperi });
Object.assign(translations.pl.group, generated.pl.group);
for (const l of ["sw", "pl"]) {
  const g = generated[l].audit || {};
  for (const k of ["marquee", "models", "micro", "capital", "pilot"]) if (g[k]) translations[l][k] = g[k];
  if (g.tco) Object.assign(translations[l].tco, g.tco);
  if (g.partners) Object.assign(translations[l].partners, g.partners);
  if (g.china) Object.assign(translations[l].china, g.china);
}
const LINK_LABELS = {
  sw: { "Amperi vehicles": "Magari ya Amperi", "AmperCity · Amperi fleets in Europe": "AmperCity · makundi ya magari ya Amperi Ulaya", "Hadron Energy · battery partner": "Hadron Energy · mshirika wa betri", "Arthur Toren · Founder": "Arthur Toren · Mwanzilishi", "electro.technology · CEO": "electro.technology · Mkurugenzi Mkuu", "EU–Africa Business Forum": "Jukwaa la Biashara EU–Afrika" },
  pl: { "Amperi vehicles": "Pojazdy Amperi", "AmperCity · Amperi fleets in Europe": "AmperCity · floty Amperi w Europie", "Hadron Energy · battery partner": "Hadron Energy · partner bateryjny", "Arthur Toren · Founder": "Arthur Toren · założyciel", "electro.technology · CEO": "electro.technology · prezes", "EU–Africa Business Forum": "Forum Biznesu UE–Afryka" },
  fr: { "Amperi vehicles": "Véhicules Amperi", "AmperCity · Amperi fleets in Europe": "AmperCity · flottes Amperi en Europe", "Hadron Energy · battery partner": "Hadron Energy · partenaire batteries", "Arthur Toren · Founder": "Arthur Toren · fondateur", "electro.technology · CEO": "electro.technology · PDG", "EU–Africa Business Forum": "Forum économique UE–Afrique" },
  zh: { "Amperi vehicles": "Amperi 电动车", "AmperCity · Amperi fleets in Europe": "AmperCity · 欧洲 Amperi 车队", "Hadron Energy · battery partner": "Hadron Energy · 电池合作伙伴", "Arthur Toren · Founder": "Arthur Toren · 创始人", "electro.technology · CEO": "electro.technology · 首席执行官", "EU–Africa Business Forum": "欧盟–非洲商业论坛" },
};
for (const l of ["sw", "pl", "fr", "zh"]) {
  translations[l].founders.items.forEach((f, i) => {
    const src = translations.en.founders.items[i];
    f.links = src.links.map((x) => ({ url: x.url, label: LINK_LABELS[l][x.label] || x.label }));
    if (src.linkedin) f.linkedin = src.linkedin;
    if (src.email) f.email = src.email;
    if (src.vcard) f.vcard = src.vcard;
    if (src.photoPos) f.photoPos = src.photoPos;
  });
  translations[l].founders.vcard = { sw: "Hifadhi mawasiliano", pl: "Zapisz kontakt", fr: "Enregistrer le contact", zh: "保存联系人" }[l];
  translations[l].founders.qrHint = { sw: "Skani ili kuhifadhi mawasiliano", pl: "Zeskanuj, aby zapisać kontakt", fr: "Scannez pour enregistrer le contact", zh: "扫码保存联系人" }[l];
  translations[l].contact.contactEmail = translations.en.contact.contactEmail;
  translations[l].footer.press = { sw: "Vyombo vya habari", pl: "Dla mediów", fr: "Presse", zh: "媒体资料" }[l];
  translations[l].seo.press = {
    sw: { title: "Kifurushi cha Habari — Maelezo ya Kampuni, Wasifu wa Waanzilishi, Picha na Nembo", description: "Taarifa kwa vyombo vya habari kuhusu MargTor Ltd.: maelezo ya kampuni, ukweli muhimu, wasifu na picha za studio za waanzilishi Gurinder Oberoi Singh na Gregory Radek, nembo na vipeperushi vya ushirikiano.", ogAlt: "Kifurushi cha habari cha MargTor Ltd.", breadcrumb: "Kifurushi cha Habari" },
    pl: { title: "Materiały prasowe — boilerplate, biogramy założycieli, portrety i logotypy", description: "Informacje dla mediów o MargTor Ltd.: boilerplate (EN/PL), fakty, biogramy i portrety studyjne założycieli Gurindera Oberoi Singha i Gregory’ego Radka, logotypy i briefy partnerskie. Teksty CC BY 4.0; zdjęcia do użytku redakcyjnego.", ogAlt: "Materiały prasowe MargTor Ltd. — boilerplate, portrety założycieli i logotypy.", breadcrumb: "Materiały prasowe" },
    fr: { title: "Dossier de presse — présentation, biographies des fondateurs, portraits et logos", description: "Informations médias sur MargTor Ltd. : texte de présentation (EN/PL), fiche d’informations, biographies et portraits studio des fondateurs Gurinder Oberoi Singh et Gregory Radek, logos et briefs partenaires.", ogAlt: "Dossier de presse MargTor Ltd.", breadcrumb: "Dossier de presse" },
    zh: { title: "新闻资料包 — 公司简介、创始人简历、肖像与标志", description: "MargTor Ltd. 媒体资料：公司简介（英/波兰文）、事实清单、创始人 Gurinder Oberoi Singh 与 Gregory Radek 的简历和工作室肖像、标志及合作简报。文字 CC BY 4.0；图片仅限编辑用途。", ogAlt: "MargTor Ltd. 新闻资料包", breadcrumb: "新闻资料包" },
  }[l];
  translations[l].contact.emailLabel = { sw: "Barua pepe", pl: "E-mail", fr: "E-mail", zh: "电子邮箱" }[l];
}
